
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireba4c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireba4c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ad2td", function(module, exports) {




/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */ (function(window1, factory) {
    'use strict';
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
    ], function(EvEmitter, getSize, utils, Item) {
        return factory(window1, EvEmitter, getSize, utils, Item);
    });
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory(window1, (parcelRequire("Vqjah")), (parcelRequire("g64Da")), (parcelRequire("9VjL6")), (parcelRequire("9OxT7")));
    else // browser global
    window1.Outlayer = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, window1.Outlayer.Item);
})(window, function factory(window1, EvEmitter, getSize, utils, Item) {
    'use strict';
    // ----- vars ----- //
    var console = window1.console;
    var jQuery = window1.jQuery;
    var noop = function() {};
    // -------------------------- Outlayer -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Outlayer intances
    var instances = {};
    /**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */ function Outlayer(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // add id for Outlayer.getFromElement
        var id = ++GUID;
        this.element.outlayerGUID = id; // expando
        instances[id] = this; // associate via id
        // kick it off
        this._create();
        var isInitLayout = this._getOption('initLayout');
        if (isInitLayout) this.layout();
    }
    // settings are for internal use only
    Outlayer.namespace = 'outlayer';
    Outlayer.Item = Item;
    // default options
    Outlayer.defaults = {
        containerStyle: {
            position: 'relative'
        },
        initLayout: true,
        originLeft: true,
        originTop: true,
        resize: true,
        resizeContainer: true,
        // item options
        transitionDuration: '0.4s',
        hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
        },
        visibleStyle: {
            opacity: 1,
            transform: 'scale(1)'
        }
    };
    var proto = Outlayer.prototype;
    // inherit EvEmitter
    utils.extend(proto, EvEmitter.prototype);
    /**
 * set options
 * @param {Object} opts
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    /**
 * get backwards compatible option value, check old name
 */ proto._getOption = function(option) {
        var oldOption = this.constructor.compatOptions[option];
        return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
    };
    Outlayer.compatOptions = {
        // currentName: oldName
        initLayout: 'isInitLayout',
        horizontal: 'isHorizontal',
        layoutInstant: 'isLayoutInstant',
        originLeft: 'isOriginLeft',
        originTop: 'isOriginTop',
        resize: 'isResizeBound',
        resizeContainer: 'isResizingContainer'
    };
    proto._create = function() {
        // get items from children
        this.reloadItems();
        // elements that affect layout, but are not laid out
        this.stamps = [];
        this.stamp(this.options.stamp);
        // set container style
        utils.extend(this.element.style, this.options.containerStyle);
        // bind resize method
        var canBindResize = this._getOption('resize');
        if (canBindResize) this.bindResize();
    };
    // goes through all children again and gets bricks in proper order
    proto.reloadItems = function() {
        // collection of item elements
        this.items = this._itemize(this.element.children);
    };
    /**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */ proto._itemize = function(elems) {
        var itemElems = this._filterFindItemElements(elems);
        var Item = this.constructor.Item;
        // create new Outlayer Items for collection
        var items = [];
        for(var i = 0; i < itemElems.length; i++){
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
        }
        return items;
    };
    /**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */ proto._filterFindItemElements = function(elems) {
        return utils.filterFindElements(elems, this.options.itemSelector);
    };
    /**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */ proto.getItemElements = function() {
        return this.items.map(function(item) {
            return item.element;
        });
    };
    // ----- init & layout ----- //
    /**
 * lays out all items
 */ proto.layout = function() {
        this._resetLayout();
        this._manageStamps();
        // don't animate first layout
        var layoutInstant = this._getOption('layoutInstant');
        var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
        this.layoutItems(this.items, isInstant);
        // flag for initalized
        this._isLayoutInited = true;
    };
    // _init is alias for layout
    proto._init = proto.layout;
    /**
 * logic before any new layout
 */ proto._resetLayout = function() {
        this.getSize();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */ proto._getMeasurement = function(measurement, size) {
        var option = this.options[measurement];
        var elem;
        if (!option) // default to 0
        this[measurement] = 0;
        else {
            // use option as an element
            if (typeof option == 'string') elem = this.element.querySelector(option);
            else if (option instanceof HTMLElement) elem = option;
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
        }
    };
    /**
 * layout a collection of item elements
 * @api public
 */ proto.layoutItems = function(items, isInstant) {
        items = this._getItemsForLayout(items);
        this._layoutItems(items, isInstant);
        this._postLayout();
    };
    /**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */ proto._getItemsForLayout = function(items) {
        return items.filter(function(item) {
            return !item.isIgnored;
        });
    };
    /**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */ proto._layoutItems = function(items, isInstant) {
        this._emitCompleteOnItems('layout', items);
        if (!items || !items.length) // no items, emit event with empty array
        return;
        var queue = [];
        items.forEach(function(item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
        }, this);
        this._processLayoutQueue(queue);
    };
    /**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */ proto._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        };
    };
    /**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */ proto._processLayoutQueue = function(queue) {
        this.updateStagger();
        queue.forEach(function(obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
        }, this);
    };
    // set stagger from option in milliseconds number
    proto.updateStagger = function() {
        var stagger = this.options.stagger;
        if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
        }
        this.stagger = getMilliseconds(stagger);
        return this.stagger;
    };
    /**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */ proto._positionItem = function(item, x, y, isInstant, i) {
        if (isInstant) // if not transition, just set CSS
        item.goTo(x, y);
        else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
        }
    };
    /**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */ proto._postLayout = function() {
        this.resizeContainer();
    };
    proto.resizeContainer = function() {
        var isResizingContainer = this._getOption('resizeContainer');
        if (!isResizingContainer) return;
        var size = this._getContainerSize();
        if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
        }
    };
    /**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */ proto._getContainerSize = noop;
    /**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */ proto._setContainerMeasure = function(measure, isWidth) {
        if (measure === undefined) return;
        var elemSize = this.size;
        // add padding and border width if border box
        if (elemSize.isBorderBox) measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
        measure = Math.max(measure, 0);
        this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
    };
    /**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */ proto._emitCompleteOnItems = function(eventName, items) {
        var _this = this;
        function onComplete() {
            _this.dispatchEvent(eventName + 'Complete', null, [
                items
            ]);
        }
        var count = items.length;
        if (!items || !count) {
            onComplete();
            return;
        }
        var doneCount = 0;
        function tick() {
            doneCount++;
            if (doneCount == count) onComplete();
        }
        // bind callback
        items.forEach(function(item) {
            item.once(eventName, tick);
        });
    };
    /**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        // add original event to arguments
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
                // create jQuery event
                var $event = jQuery.Event(event);
                $event.type = type;
                this.$element.trigger($event, args);
            } else // just trigger with type if no event available
            this.$element.trigger(type, args);
        }
    };
    // -------------------------- ignore & stamps -------------------------- //
    /**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */ proto.ignore = function(elem) {
        var item = this.getItem(elem);
        if (item) item.isIgnored = true;
    };
    /**
 * return item to layout collection
 * @param {Element} elem
 */ proto.unignore = function(elem) {
        var item = this.getItem(elem);
        if (item) delete item.isIgnored;
    };
    /**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */ proto.stamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        this.stamps = this.stamps.concat(elems);
        // ignore
        elems.forEach(this.ignore, this);
    };
    /**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */ proto.unstamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        elems.forEach(function(elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
        }, this);
    };
    /**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */ proto._find = function(elems) {
        if (!elems) return;
        // if string, use argument as selector string
        if (typeof elems == 'string') elems = this.element.querySelectorAll(elems);
        elems = utils.makeArray(elems);
        return elems;
    };
    proto._manageStamps = function() {
        if (!this.stamps || !this.stamps.length) return;
        this._getBoundingRect();
        this.stamps.forEach(this._manageStamp, this);
    };
    // update boundingLeft / Top
    proto._getBoundingRect = function() {
        // get bounding rect for container element
        var boundingRect = this.element.getBoundingClientRect();
        var size = this.size;
        this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
        };
    };
    /**
 * @param {Element} stamp
**/ proto._manageStamp = noop;
    /**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */ proto._getElementOffset = function(elem) {
        var boundingRect = elem.getBoundingClientRect();
        var thisRect = this._boundingRect;
        var size = getSize(elem);
        var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
        };
        return offset;
    };
    // -------------------------- resize -------------------------- //
    // enable event handlers for listeners
    // i.e. resize -> onresize
    proto.handleEvent = utils.handleEvent;
    /**
 * Bind layout to window resizing
 */ proto.bindResize = function() {
        window1.addEventListener('resize', this);
        this.isResizeBound = true;
    };
    /**
 * Unbind layout to window resizing
 */ proto.unbindResize = function() {
        window1.removeEventListener('resize', this);
        this.isResizeBound = false;
    };
    proto.onresize = function() {
        this.resize();
    };
    utils.debounceMethod(Outlayer, 'onresize', 100);
    proto.resize = function() {
        // don't trigger if size did not change
        // or if resize was unbound. See #9
        if (!this.isResizeBound || !this.needsResizeLayout()) return;
        this.layout();
    };
    /**
 * check if layout is needed post layout
 * @returns Boolean
 */ proto.needsResizeLayout = function() {
        var size = getSize(this.element);
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var hasSizes = this.size && size;
        return hasSizes && size.innerWidth !== this.size.innerWidth;
    };
    // -------------------------- methods -------------------------- //
    /**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/ proto.addItems = function(elems) {
        var items = this._itemize(elems);
        // add items to collection
        if (items.length) this.items = this.items.concat(items);
        return items;
    };
    /**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */ proto.appended = function(elems) {
        var items = this.addItems(elems);
        if (!items.length) return;
        // layout and reveal just the new items
        this.layoutItems(items, true);
        this.reveal(items);
    };
    /**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */ proto.prepended = function(elems) {
        var items = this._itemize(elems);
        if (!items.length) return;
        // add items to beginning of collection
        var previousItems = this.items.slice(0);
        this.items = items.concat(previousItems);
        // start new layout
        this._resetLayout();
        this._manageStamps();
        // layout new stuff without transition
        this.layoutItems(items, true);
        this.reveal(items);
        // layout previous items
        this.layoutItems(previousItems);
    };
    /**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.reveal = function(items) {
        this._emitCompleteOnItems('reveal', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.reveal();
        });
    };
    /**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.hide = function(items) {
        this._emitCompleteOnItems('hide', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.hide();
        });
    };
    /**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.revealItemElements = function(elems) {
        var items = this.getItems(elems);
        this.reveal(items);
    };
    /**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.hideItemElements = function(elems) {
        var items = this.getItems(elems);
        this.hide(items);
    };
    /**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */ proto.getItem = function(elem) {
        // loop through items to get the one that matches
        for(var i = 0; i < this.items.length; i++){
            var item = this.items[i];
            if (item.element == elem) // return item
            return item;
        }
    };
    /**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */ proto.getItems = function(elems) {
        elems = utils.makeArray(elems);
        var items = [];
        elems.forEach(function(elem) {
            var item = this.getItem(elem);
            if (item) items.push(item);
        }, this);
        return items;
    };
    /**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */ proto.remove = function(elems) {
        var removeItems = this.getItems(elems);
        this._emitCompleteOnItems('remove', removeItems);
        // bail if no items to remove
        if (!removeItems || !removeItems.length) return;
        removeItems.forEach(function(item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
        }, this);
    };
    // ----- destroy ----- //
    // remove and disable Outlayer instance
    proto.destroy = function() {
        // clean up dynamic styles
        var style = this.element.style;
        style.height = '';
        style.position = '';
        style.width = '';
        // destroy items
        this.items.forEach(function(item) {
            item.destroy();
        });
        this.unbindResize();
        var id = this.element.outlayerGUID;
        delete instances[id]; // remove reference to instance by id
        delete this.element.outlayerGUID;
        // remove data for jQuery
        if (jQuery) jQuery.removeData(this.element, this.constructor.namespace);
    };
    // -------------------------- data -------------------------- //
    /**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */ Outlayer.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.outlayerGUID;
        return id && instances[id];
    };
    // -------------------------- create Outlayer class -------------------------- //
    /**
 * create a layout class
 * @param {String} namespace
 */ Outlayer.create = function(namespace, options) {
        // sub-class Outlayer
        var Layout = subclass(Outlayer);
        // apply new options and compatOptions
        Layout.defaults = utils.extend({}, Outlayer.defaults);
        utils.extend(Layout.defaults, options);
        Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
        Layout.namespace = namespace;
        Layout.data = Outlayer.data;
        // sub-class Item
        Layout.Item = subclass(Item);
        // -------------------------- declarative -------------------------- //
        utils.htmlInit(Layout, namespace);
        // -------------------------- jQuery bridge -------------------------- //
        // make into jQuery plugin
        if (jQuery && jQuery.bridget) jQuery.bridget(namespace, Layout);
        return Layout;
    };
    function subclass(Parent) {
        function SubClass() {
            Parent.apply(this, arguments);
        }
        SubClass.prototype = Object.create(Parent.prototype);
        SubClass.prototype.constructor = SubClass;
        return SubClass;
    }
    // ----- helpers ----- //
    // how many milliseconds are in each unit
    var msUnits = {
        ms: 1,
        s: 1000
    };
    // munge time-like parameter into millisecond number
    // '0.4s' -> 40
    function getMilliseconds(time) {
        if (typeof time == 'number') return time;
        var matches = time.match(/(^\d*\.?\d*)(\w*)/);
        var num = matches && matches[1];
        var unit = matches && matches[2];
        if (!num.length) return 0;
        num = parseFloat(num);
        var mult = msUnits[unit] || 1;
        return num * mult;
    }
    // ----- fin ----- //
    // back in global
    Outlayer.Item = Item;
    return Outlayer;
});

});
parcelRegister("Vqjah", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRegister("g64Da", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    'use strict';
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == 'undefined' ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("9VjL6", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'desandro-matches-selector/matches-selector'
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("hfvjA")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    'use strict';
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener('DOMContentLoaded', callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRegister("hfvjA", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ 'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    'use strict';
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return 'matches';
        // check un-prefixed
        if (ElemProto.matchesSelector) return 'matchesSelector';
        // check vendor prefixes
        var prefixes = [
            'webkit',
            'moz',
            'ms',
            'o'
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRegister("9OxT7", function(module, exports) {


/**
 * Outlayer Item
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size'
    ], factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory((parcelRequire("Vqjah")), (parcelRequire("g64Da")));
    else {
        // browser global
        window1.Outlayer = {};
        window1.Outlayer.Item = factory(window1.EvEmitter, window1.getSize);
    }
})(window, function factory(EvEmitter, getSize) {
    'use strict';
    // ----- helpers ----- //
    function isEmptyObj(obj) {
        for(var prop in obj)return false;
        prop = null;
        return true;
    }
    // -------------------------- CSS3 support -------------------------- //
    var docElemStyle = document.documentElement.style;
    var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
    var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    var transitionEndEvent = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend'
    }[transitionProperty];
    // cache all vendor properties that could have vendor prefix
    var vendorProperties = {
        transform: transformProperty,
        transition: transitionProperty,
        transitionDuration: transitionProperty + 'Duration',
        transitionProperty: transitionProperty + 'Property',
        transitionDelay: transitionProperty + 'Delay'
    };
    // -------------------------- Item -------------------------- //
    function Item(element, layout) {
        if (!element) return;
        this.element = element;
        // parent layout class, i.e. Masonry, Isotope, or Packery
        this.layout = layout;
        this.position = {
            x: 0,
            y: 0
        };
        this._create();
    }
    // inherit EvEmitter
    var proto = Item.prototype = Object.create(EvEmitter.prototype);
    proto.constructor = Item;
    proto._create = function() {
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.css({
            position: 'absolute'
        });
    };
    // trigger specified handler for event type
    proto.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * apply CSS styles to element
 * @param {Object} style
 */ proto.css = function(style) {
        var elemStyle = this.element.style;
        for(var prop in style){
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
        }
    };
    // measure position, and sets it
    proto.getPosition = function() {
        var style = getComputedStyle(this.element);
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        var xValue = style[isOriginLeft ? 'left' : 'right'];
        var yValue = style[isOriginTop ? 'top' : 'bottom'];
        var x = parseFloat(xValue);
        var y = parseFloat(yValue);
        // convert percent to pixels
        var layoutSize = this.layout.size;
        if (xValue.indexOf('%') != -1) x = x / 100 * layoutSize.width;
        if (yValue.indexOf('%') != -1) y = y / 100 * layoutSize.height;
        // clean up 'auto' or other non-integer values
        x = isNaN(x) ? 0 : x;
        y = isNaN(y) ? 0 : y;
        // remove padding from measurement
        x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
        y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
        this.position.x = x;
        this.position.y = y;
    };
    // set settled position, apply padding
    proto.layoutPosition = function() {
        var layoutSize = this.layout.size;
        var style = {};
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        // x
        var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
        var xProperty = isOriginLeft ? 'left' : 'right';
        var xResetProperty = isOriginLeft ? 'right' : 'left';
        var x = this.position.x + layoutSize[xPadding];
        // set in percentage or pixels
        style[xProperty] = this.getXValue(x);
        // reset other property
        style[xResetProperty] = '';
        // y
        var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
        var yProperty = isOriginTop ? 'top' : 'bottom';
        var yResetProperty = isOriginTop ? 'bottom' : 'top';
        var y = this.position.y + layoutSize[yPadding];
        // set in percentage or pixels
        style[yProperty] = this.getYValue(y);
        // reset other property
        style[yResetProperty] = '';
        this.css(style);
        this.emitEvent('layout', [
            this
        ]);
    };
    proto.getXValue = function(x) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
    };
    proto.getYValue = function(y) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
    };
    proto._transitionTo = function(x, y) {
        this.getPosition();
        // get current x & y from top/left
        var curX = this.position.x;
        var curY = this.position.y;
        var didNotMove = x == this.position.x && y == this.position.y;
        // save end position
        this.setPosition(x, y);
        // if did not move and not transitioning, just go to layout
        if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
        }
        var transX = x - curX;
        var transY = y - curY;
        var transitionStyle = {};
        transitionStyle.transform = this.getTranslate(transX, transY);
        this.transition({
            to: transitionStyle,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: true
        });
    };
    proto.getTranslate = function(x, y) {
        // flip cooridinates if origin on right or bottom
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        x = isOriginLeft ? x : -x;
        y = isOriginTop ? y : -y;
        return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    };
    // non transition + transform support
    proto.goTo = function(x, y) {
        this.setPosition(x, y);
        this.layoutPosition();
    };
    proto.moveTo = proto._transitionTo;
    proto.setPosition = function(x, y) {
        this.position.x = parseFloat(x);
        this.position.y = parseFloat(y);
    };
    // ----- transition ----- //
    /**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */ // non transition, just trigger callback
    proto._nonTransition = function(args) {
        this.css(args.to);
        if (args.isCleaning) this._removeStyles(args.to);
        for(var prop in args.onTransitionEnd)args.onTransitionEnd[prop].call(this);
    };
    /**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */ proto.transition = function(args) {
        // redirect to nonTransition if no transition duration
        if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
        }
        var _transition = this._transn;
        // keep track of onTransitionEnd callback by css property
        for(var prop in args.onTransitionEnd)_transition.onEnd[prop] = args.onTransitionEnd[prop];
        // keep track of properties that are transitioning
        for(prop in args.to){
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) _transition.clean[prop] = true;
        }
        // set from styles
        if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            var h = this.element.offsetHeight;
            // hack for JSHint to hush about unused var
            h = null;
        }
        // enable transition
        this.enableTransition(args.to);
        // set styles that are transitioning
        this.css(args.to);
        this.isTransitioning = true;
    };
    // dash before all cap letters, including first for
    // WebkitTransform => -webkit-transform
    function toDashedAll(str) {
        return str.replace(/([A-Z])/g, function($1) {
            return '-' + $1.toLowerCase();
        });
    }
    var transitionProps = 'opacity,' + toDashedAll(transformProperty);
    proto.enableTransition = function() {
        // HACK changing transitionProperty during a transition
        // will cause transition to jump
        if (this.isTransitioning) return;
        // make `transition: foo, bar, baz` from style object
        // HACK un-comment this when enableTransition can work
        // while a transition is happening
        // var transitionValues = [];
        // for ( var prop in style ) {
        //   // dash-ify camelCased properties like WebkitTransition
        //   prop = vendorProperties[ prop ] || prop;
        //   transitionValues.push( toDashedAll( prop ) );
        // }
        // munge number to millisecond, to match stagger
        var duration = this.layout.options.transitionDuration;
        duration = typeof duration == 'number' ? duration + 'ms' : duration;
        // enable transition styles
        this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0
        });
        // listen for transition end event
        this.element.addEventListener(transitionEndEvent, this, false);
    };
    // ----- events ----- //
    proto.onwebkitTransitionEnd = function(event) {
        this.ontransitionend(event);
    };
    proto.onotransitionend = function(event) {
        this.ontransitionend(event);
    };
    // properties that I munge to make my life easier
    var dashedVendorProperties = {
        '-webkit-transform': 'transform'
    };
    proto.ontransitionend = function(event) {
        // disregard bubbled events from children
        if (event.target !== this.element) return;
        var _transition = this._transn;
        // get property name of transitioned property, convert to prefix-free
        var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;
        // remove property that has completed transitioning
        delete _transition.ingProperties[propertyName];
        // check if any properties are still transitioning
        if (isEmptyObj(_transition.ingProperties)) // all properties have completed transitioning
        this.disableTransition();
        // clean style
        if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = '';
            delete _transition.clean[propertyName];
        }
        // trigger onTransitionEnd callback
        if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
        }
        this.emitEvent('transitionEnd', [
            this
        ]);
    };
    proto.disableTransition = function() {
        this.removeTransitionStyles();
        this.element.removeEventListener(transitionEndEvent, this, false);
        this.isTransitioning = false;
    };
    /**
 * removes style property from element
 * @param {Object} style
**/ proto._removeStyles = function(style) {
        // clean up transition styles
        var cleanStyle = {};
        for(var prop in style)cleanStyle[prop] = '';
        this.css(cleanStyle);
    };
    var cleanTransitionStyle = {
        transitionProperty: '',
        transitionDuration: '',
        transitionDelay: ''
    };
    proto.removeTransitionStyles = function() {
        // remove transition
        this.css(cleanTransitionStyle);
    };
    // ----- stagger ----- //
    proto.stagger = function(delay) {
        delay = isNaN(delay) ? 0 : delay;
        this.staggerDelay = delay + 'ms';
    };
    // ----- show/hide/remove ----- //
    // remove element from DOM
    proto.removeElem = function() {
        this.element.parentNode.removeChild(this.element);
        // remove display: none
        this.css({
            display: ''
        });
        this.emitEvent('remove', [
            this
        ]);
    };
    proto.remove = function() {
        // just remove element if no transition support or no transition
        if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
        }
        // start transition
        this.once('transitionEnd', function() {
            this.removeElem();
        });
        this.hide();
    };
    proto.reveal = function() {
        delete this.isHidden;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
        onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
        this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onRevealTransitionEnd = function() {
        // check if still visible
        // during transition, item may have been hidden
        if (!this.isHidden) this.emitEvent('reveal');
    };
    /**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */ proto.getHideRevealTransitionEndProperty = function(styleProperty) {
        var optionStyle = this.layout.options[styleProperty];
        // use opacity
        if (optionStyle.opacity) return 'opacity';
        // get first property
        for(var prop in optionStyle)return prop;
    };
    proto.hide = function() {
        // set flag
        this.isHidden = true;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
        onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
        this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onHideTransitionEnd = function() {
        // check if still hidden
        // during transition, item may have been un-hidden
        if (this.isHidden) {
            this.css({
                display: 'none'
            });
            this.emitEvent('hide');
        }
    };
    proto.destroy = function() {
        this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: ''
        });
    };
    return Item;
});

});


// your main JavaScript file
// imports --------------------------------------------------------------------
// import * as Cookies from './0-cookies-v3.1.js';
// all your go to vars in one place
// imports --------------------------------------------------------------------
// exported variables ---------------------------------------------------------
let $183c77cc0773b3dc$export$507ba88fae84526c = false;
let $183c77cc0773b3dc$export$91babf9946b452e6 = false;
let $183c77cc0773b3dc$export$3e356d72a203df8 = false;
let $183c77cc0773b3dc$export$304e9ef5c0115306 = false;
let $183c77cc0773b3dc$export$8d64596ba1e90411 = false;
let $183c77cc0773b3dc$export$73e6618aa19ac9d5 = false;
let $183c77cc0773b3dc$export$26bd91a1ebe4bab5 = false;
let $183c77cc0773b3dc$export$535000180c47d75e = false;
let $183c77cc0773b3dc$export$5302e2a3cf8cbbaa = false;
let $183c77cc0773b3dc$export$6326feb87d4c7047 = false;
let $183c77cc0773b3dc$export$8eb131372814d7e3 = false;
let $183c77cc0773b3dc$export$e0fbcefc9dd1fa7 = false;
const $183c77cc0773b3dc$export$bc5e1f7fdf0656e1 = 200;
const $183c77cc0773b3dc$export$35a4a76088200152 = 400;
const $183c77cc0773b3dc$export$34977f05af4bf228 = 800;
const $183c77cc0773b3dc$export$e57b424cfcf1fb09 = 1000;
const $183c77cc0773b3dc$export$abb3878d4b973569 = 1600;
const $183c77cc0773b3dc$export$f09585a853dddd32 = 1400;
const $183c77cc0773b3dc$export$3c17b0e969a90510 = 1200;
const $183c77cc0773b3dc$export$74c1bba07084d12b = 1023;
const $183c77cc0773b3dc$export$85892fb6dad8d20d = 800;
const $183c77cc0773b3dc$export$1c4e7a9c31a6c071 = 599;
const $183c77cc0773b3dc$export$3488ed6e3b665cea = 374;
const $183c77cc0773b3dc$export$a49f1701c92af4f = 440;
const $183c77cc0773b3dc$export$9c77cf683b3c1e05 = window.matchMedia('(min-width: ' + $183c77cc0773b3dc$export$e57b424cfcf1fb09 + 'px)');
const $183c77cc0773b3dc$export$9753f319f7585cb0 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$abb3878d4b973569 + 'px)');
const $183c77cc0773b3dc$export$f70805195fbb99f5 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$f09585a853dddd32 + 'px)');
const $183c77cc0773b3dc$export$a25adc3e4b57e050 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$3c17b0e969a90510 + 'px)');
const $183c77cc0773b3dc$export$83d079efc99ca320 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$74c1bba07084d12b + 'px)');
const $183c77cc0773b3dc$export$64334b5f702ba3ba = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$85892fb6dad8d20d + 'px)');
const $183c77cc0773b3dc$export$29bd02b533ce69bd = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$1c4e7a9c31a6c071 + 'px)');
const $183c77cc0773b3dc$export$81644d96c4abed35 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$3488ed6e3b665cea + 'px)');
const $183c77cc0773b3dc$export$2f3a650ac1036195 = window.matchMedia('(max-height: ' + $183c77cc0773b3dc$export$a49f1701c92af4f + 'px)');
const $183c77cc0773b3dc$export$e7766e37c74cc06c = window.matchMedia('(prefers-color-scheme: dark)');
const $183c77cc0773b3dc$export$dd32b77e25b56ab8 = window.matchMedia('(orientation: portrait)');
const $183c77cc0773b3dc$export$90d0ea046136e3ed = ()=>{
    // console.log('initVars');
    const ua = navigator.userAgent;
    // check for touch
    if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
        document.body.classList.add('body--touch');
        $183c77cc0773b3dc$export$507ba88fae84526c = true;
    }
    // check for scrollbar
    if ($183c77cc0773b3dc$var$realSize().width != window.innerWidth) {
        document.body.classList.add('body--scrollbar');
        $183c77cc0773b3dc$export$91babf9946b452e6 = true;
    }
    // check for android
    if (ua.toLowerCase().indexOf('android') > -1) {
        document.body.classList.add('body--android');
        $183c77cc0773b3dc$export$3e356d72a203df8 = true;
    }
    // check for ios
    if ([
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || ua.includes('Mac') && 'ontouchend' in document) {
        document.body.classList.add('body--ios');
        $183c77cc0773b3dc$export$304e9ef5c0115306 = true;
    }
    // check for ipad
    if (ua.indexOf('iPad') > -1) {
        document.body.classList.add('body--ipad');
        $183c77cc0773b3dc$export$8d64596ba1e90411 = true;
    }
    // check for safari
    if (ua.indexOf('Safari') != -1 && ua.indexOf('Chrome') == -1) {
        document.body.classList.add('body--safari');
        $183c77cc0773b3dc$export$73e6618aa19ac9d5 = true;
    }
    // check for firefox
    if (ua.toLowerCase().indexOf('firefox') > -1) {
        document.body.classList.add('body--firefox');
        $183c77cc0773b3dc$export$26bd91a1ebe4bab5 = true;
    }
    // check for ie
    if (window.document.documentMode) {
        document.body.classList.add('body--ie');
        $183c77cc0773b3dc$export$535000180c47d75e = true;
    }
    // check for edge
    if (ua.indexOf('Edge') > -1) {
        document.body.classList.add('body--edge');
        $183c77cc0773b3dc$export$5302e2a3cf8cbbaa = true;
    }
    // check for windows
    if (navigator.platform.indexOf('Win') > -1) {
        document.body.classList.add('body--windows');
        $183c77cc0773b3dc$export$6326feb87d4c7047 = true;
    }
    // check for chrome
    if (/Chrome/.test(ua) && /Google Inc/.test(navigator.vendor)) {
        document.body.classList.add('body--chrome');
        $183c77cc0773b3dc$export$8eb131372814d7e3 = true;
    }
    // check for blend modes
    if ('CSS' in window && 'supports' in window.CSS) {
        let support = window.CSS.supports('mix-blend-mode', 'soft-light');
        support = support ? 'body--mix-blend-mode' : 'body--no-mix-blend-mode';
        document.body.classList.add(support);
    }
    // check for retina
    const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
    if (mq && mq.matches || window.devicePixelRatio > 1) {
        document.body.classList.add('body--retina');
        $183c77cc0773b3dc$export$e0fbcefc9dd1fa7 = true;
    }
};
// used to get the realSize width including the scrollbar
// this is needed to get the same width as the mediaqueries in css
const $183c77cc0773b3dc$var$realSize = ()=>{
    let doc = window;
    let name = 'inner';
    if (!('innerWidth' in window)) {
        name = 'client';
        doc = document.documentElement || document.body;
    }
    return {
        width: doc[name + 'Width'],
        height: doc[name + 'Height']
    };
};


// do these things only once
// even if you are using a history.js navigation
// imports --------------------------------------------------------------------

var $56a526a578fe3239$exports = {};

$parcel$export($56a526a578fe3239$exports, "fader", () => $56a526a578fe3239$export$760c9eb46059594c);
$parcel$export($56a526a578fe3239$exports, "pageTypePrev", () => $56a526a578fe3239$export$bba485742287c13f);
$parcel$export($56a526a578fe3239$exports, "initOnce", () => $56a526a578fe3239$export$caa6e1ba6b757214);
$parcel$export($56a526a578fe3239$exports, "observerBlocker", () => $56a526a578fe3239$export$2f5ac5bcfd51f435);
$parcel$export($56a526a578fe3239$exports, "observerUnblocker", () => $56a526a578fe3239$export$5a0a8e9ff7c0e4a7);
// do these things only once
// even if you are using a history.js navigation
// imports --------------------------------------------------------------------
// Fader V7.2
// used for fading in items, if needed after being loaded, based on scroll
// also copy _fader.scss
// init: fader = new Fader();
// usage: add fader class to items that should fade
// set fader and fader--loader class on loading element or a parent element
// add fader--lazy on fader--loader for lazyloading
// loader can de used for a single image, video or background-image
// use data-src and data-srcset instead of src(set)
// can use data-src(set)-mobile
// can use data-src-fullscreen with fader--fullscreen
// add fader--repeat to fade every time it crosses a fold
// add fader--top to fade at the top fold too
// add fader--below-fold to fade elements that are below/above the fold
// add fader--force to force fade on element in view when skipOnLoadInView is true, handy for elements not used in view-transitions
// add fader--still to fade in without movement, just opacity
// add fader--no-fade to not fade in, but just show the element
// add fader--clip to clip the element, instead of opacity
// add fader--no-stagger to not stagger the fade in, can still use data-fader-delay
// required properties:
// none
// possible properties:
// fadeDur = 1200: set this to fader.scss fade speed, in ms
// stagger = 80: in ms
// maxFades = 40: max number of staggering items
// preFadeResizeDur = 100: for resizing used after knowing image size, in ms,
// set to image size transition duration
// afterLoadFunction = '': because now stuff has loaded and size is known call this function
// fadeScrollersSelector = '': what selectors uses fade except the body
// classesToRemove = []: what classes should be removed from the element that you added
// to the css, for instance ['fader--grow']
// noFadeOnInit = true: set to true to not fade immediately when creating fader
// if you are looking on a horizontal mobile device. Probably set to false if using
// video that covers the viewport. Set to true if just using a smaller filesize
// mobileMq = '(max-width: 599px)': decides when the data-src(set)-mobile is used
// blockResizeObserver = false: block the observer from calling setFaders
// lazyFoldDiff = 1000: load images before they are visible for lazyFoldDiff pixels
// fadeBelowFold = false: fade elements that are below the fold
// skipOnLoadInView = false: skip fading if element is already in view because of LCP/FCP, also useful so elements used in view-transitions are faded in on page switch
// addStaggerToFaderDelay = true: turn false to only use data-fader-delay instead of stagger ánd data-fader-delay (fader--no-stagger does the same)
// forceDelay = 600: set a custom delay for forced faders, so they fade after view transition
// methods:
// fader.setFaders() when new content is added to the page
// fader.fadeBlocks() if scroll doesn't fire
// fader.fadeInHolderAgain(holderSelector) to redo fade
// fader.fadeElementsAgain(selector) to redo fade
// use .fader--loaded to remove temporary heights for images, for example:
// min-height: 0;
// transition: .2s min-height;
// &:not(.fader--loaded) {
//   min-height: 10rem;
// }
// Changelog
// 4.0 can switch between regular src and mobile src continuously
// 4.1 custom mobileWidth
// 4.1.1 fix for offscreen safari video
// 4.1.2 fix for unmuted videos not playing
// 4.2 switch media queries more nicely and only where needed
// 4.3 css support for clipping
// 4.4 fixes for changing variables
// 4.5 added resize observer
// 4.5.1 eslint
// 4.5.2 add blockResizeObserver fix, cleanup
// 4.5.3 fix resize observer
// 4.6 add no stagger option
// 4.6.2 fix for safari video, cleanup
// 4.6.2 new cover class
// 4.6.3 fix for cover video
// 4.7 new --no-fade, --still, --clip fixes, separate animation duration
// 4.7.1 fix bug with no fade for loaded elements
// 5.0 add lazyload option
// 6.0 no jquery
// 6.1 cleanup
// 6.1.1 use correct window sizes
// 6.2 two seperate fade again functions
// 6.2.1 fix for safari
// 6.2.2 fix wrong offset, add custom lazyFoldDiff
// 6.2.3 cleanup and bugfixes
// 6.2.4 cleanup of getAttribute code
// 6.3 add audio support
// 6.4 fix non-autoplay video autoplaying on ios
// 6.5 add fade below fold option (to hide fade / flash)
// 6.6 fix for faders in scrolling elements, cleanup
// 6.6.1 don't fade again if still fading
// 6.7 add fader repeat option
// 6.8 add top option to fade again
// 6.9 add option for different transition from above fold
// 6.9.1 fix for empty fadeScrollersSelector
// 6.10 add individual fade below option using fader--below-fold
// 6.11 don't fade invisible elements
// 6.12 add data-fader-delay option
// 6.13 new transform options
// 6.14 firefox animation improvements
// 6.15 fix stagger timing
// 6.16 add fader--fullscreen option, which uses data-src-fullscreen, fixes to resizing
// 6.16.1 only add load listeners to element with new src, call less fadeblocks after load
// 6.16.2 fix for loading fixed elements
// 6.17 fix for calling function after load
// 6.18 make resetLoaderElement public
// 6.19 check if src is set before loading with it
// 6.20 fix fadeBelowFold with fader--loader
// 6.21 fix flicker from fader--loader
// 6.22 add retina firefox translate support
// 6.23 don't reload media when repeating fade
// 6.24 fix for weird html characters in src
// 6.25 fix for no js browsers
// 6.26 take transform into account for position
// 6.27 trim sources and fix weird characters
// 6.28 don't use LF scss/css vars
// 6.29 fix for no fade on elements that are in view on load
// 6.30 fixes for fcp/lcp
// 6.31 fix 'fade again' for in view on load elements
// 6.32 fix weird characters some more
// 6.33 fixes for skip on load in view
// 6.34 mobile check is now a media query instead of a width check + remove showMobileVideoSrcOnMobileHor
// 6.35 no stagger on test fader
// 6.36 no !important
// 6.37 add fader--force to force fade in when skipping on load in view
// 6.38 add addFaderDelayToStagger option to use data-fader-delay instead of stagger
// 6.39 fixes addFaderDelayToStagger => addStaggerToFaderDelay + fixes + maxFades to 40
// 7.0 can now fade again even when previous fade is not done, both via a function and via scroll
// 7.1 add delay on fader--force, so they fade after view transition
// 7.2 correctly check position for skipOnLoadInView
// Backlog
// use data attributes instead of dataset
class $0b34a3644a6f4c48$export$2e2bcd8739ae039 {
    constructor({ fadeDur: fadeDur = 1200, stagger: stagger = 80, maxFades: maxFades = 40, preFadeResizeDur: preFadeResizeDur = 0, afterLoadFunction: afterLoadFunction = '', fadeScrollersSelector: fadeScrollersSelector = '', classesToRemove: classesToRemove = [], fadeOnInit: fadeOnInit = true, mobileMq: mobileMq = '(max-width: 599px)', blockResizeObserver: blockResizeObserver = false, lazyFoldDiff: lazyFoldDiff = 1000, fadeBelowFold: fadeBelowFold = false, skipOnLoadInView: skipOnLoadInView = false, addStaggerToFaderDelay: addStaggerToFaderDelay = true, forceDelay: forceDelay = 600 } = ''){
        // console.log('Fader');
        // user variables ------------------------------------------------------------
        // can be changed based on a media query for instance and read
        this.fadeDur = fadeDur;
        this.stagger = stagger;
        this.maxFades = maxFades;
        this.preFadeResizeDur = preFadeResizeDur;
        this.afterLoadFunction = afterLoadFunction;
        this.fadeScrollersSelector = fadeScrollersSelector;
        this.classesToRemove = classesToRemove;
        this.fadeOnInit = fadeOnInit;
        this.blockResizeObserver = blockResizeObserver;
        this.lazyFoldDiff = lazyFoldDiff;
        this.fadeBelowFold = fadeBelowFold;
        this.skipOnLoadInView = skipOnLoadInView;
        this.addStaggerToFaderDelay = addStaggerToFaderDelay;
        this.forceDelay = forceDelay;
        // scope variables -----------------------------------------------------------
        let fadersAnimating = 0;
        const mqMobile = window.matchMedia(mobileMq);
        const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        const ua = navigator.userAgent;
        if (ua.toLowerCase().indexOf('firefox') > -1) document.body.classList.add('body--firefox');
        const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
        if (mq && mq.matches || window.devicePixelRatio > 1) document.body.classList.add('body--retina');
        let windowWidth = 0;
        let windowHeight = 0;
        let prevObserverWidth = 0;
        let prevObserverHeight = 0;
        let fold = window.innerHeight; // must use innerHeight because of ios: is actual height of screen
        let lazyFold = fold + this.lazyFoldDiff; // load images before they are visible
        let fadeBlocksTimeout;
        const fastLoadDuration = 100;
        // functions -----------------------------------------------------------------
        const getLoadElement = (element)=>{
            // console.log('getLoadElement', {element});
            let loadableElement;
            if (element.tagName === 'IMG' || element.tagName === 'VIDEO' || element.tagName === 'AUDIO' || getComputedStyle(element).backgroundImage !== 'none') loadableElement = element;
            else {
                const selector = 'img[data-src], video[data-src], audio[data-src], *[style*="background-image:"]';
                loadableElement = element.querySelector(selector);
            }
            return loadableElement;
        };
        // when new fader content is added, call this
        this.setFaders = ()=>{
            // console.log('setFaders');
            windowWidth = document.documentElement.clientWidth;
            windowHeight = document.documentElement.clientHeight;
            fold = window.innerHeight;
            lazyFold = fold + this.lazyFoldDiff;
            // calculate --vert
            faderEl.classList.remove('fader');
            const startTop = faderEl.getBoundingClientRect().top;
            faderEl.classList.add('fader', 'fader--no-stagger');
            const endTop = faderEl.getBoundingClientRect().top;
            vert = startTop - endTop;
            const fadeSelectorHandler = (event)=>{
                this.fadeBlocks(event.target);
            };
            if (this.fadeScrollersSelector !== '') {
                const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
                fadeScrollers.forEach((element)=>{
                    element.removeEventListener('scroll', fadeSelectorHandler);
                    element.addEventListener('scroll', fadeSelectorHandler);
                });
            }
            const faderElements = document.querySelectorAll('.fader');
            faderElements.forEach((element)=>{
                let hasFastLoad = false;
                if (element.classList.contains('fader--fast-load')) {
                    hasFastLoad = true;
                    // don't add fast-load class to data-class
                    // because its should only be used on page load
                    element.classList.remove('fader--fast-load');
                }
                if (!element.getAttribute('data-class')) element.setAttribute('data-class', element.getAttribute('class'));
                if (hasFastLoad) element.classList.add('fader--fast-load');
                element.classList.add('fader2');
                // if above fold, add top transform
                if (element.classList.contains('fader--top')) {
                    const rect = element.getBoundingClientRect();
                    if (rect.bottom < rect.height) element.classList.add('fader--top-start'); // not < 0, because a little wiggle room
                }
            });
            const loaderElements = document.querySelectorAll('.fader--loaded:not(.fader--lazy), .fader--loader:not(.fader--lazy)');
            loaderElements.forEach((element)=>{
                // console.log('loadElement not lazy', {element});
                loadElement(element);
            });
            fadeTimeout();
        };
        this.resetLoaderElement = (element)=>{
            // console.log('resetLoaderElement', {element});
            tryRemoveFaderProperties(element);
            element.classList.remove('fader--loaded');
            element.classList.remove('fader--loading');
            element.classList.add('fader');
            element.classList.add('fader--loader');
            element.dataset.fadeFromScroll = '';
            element.dataset.fadeFromLoad = '';
            element.dataset.faded = '';
            const loadEl = getLoadElement(element);
            if (loadEl.tagName === 'IMG' || loadEl.tagName === 'VIDEO') {
                loadEl.setAttribute('src', '');
                loadEl.setAttribute('srcset', '');
            }
        };
        const loadElement = (element)=>{
            // console.log('loadElement', {element});
            let loadEl = getLoadElement(element);
            if (!loadEl) {
                // console.log('nothing to load, remove loader, just fade');
                element.classList.remove('fader--loader');
                return;
            }
            // if invisible and not audio, don't fade
            const position = window.getComputedStyle(element).getPropertyValue('position');
            if (element.offsetParent === null && position !== 'fixed' && element.tagName !== 'AUDIO' && loadEl.tagName !== 'AUDIO') return;
            // console.log('loadElement 2', {element}, {loadEl});
            const src = loadEl.getAttribute('data-src');
            const srcMobile = loadEl.getAttribute('data-src-mobile');
            if (loadEl.tagName === 'IMG') {
                // images ----------------------------
                const srcset = loadEl.getAttribute('data-srcset');
                const srcsetMobile = loadEl.getAttribute('data-srcset-mobile');
                if (srcMobile && mqMobile.matches) addImgLoadCheck(element, loadEl, srcMobile, srcsetMobile);
                else if (src) // not mobile
                addImgLoadCheck(element, loadEl, src, srcset);
            } else if (loadEl.tagName === 'VIDEO' || loadEl.tagName === 'AUDIO') {
                // video and audio ----------------------------
                const srcFullscreen = loadEl.getAttribute('data-src-fullscreen');
                const isFullscreen = element.classList.contains('fader--fullscreen');
                if (srcMobile && mqMobile.matches) // mobile
                addVideoAudioLoadCheck(element, loadEl, srcMobile);
                else if (srcFullscreen && isFullscreen) // fullscreen
                addVideoAudioLoadCheck(element, loadEl, srcFullscreen);
                else if (src) // not mobile or fullscreen
                addVideoAudioLoadCheck(element, loadEl, src);
            } else {
                // background images ----------------------------
                const bgImg = getComputedStyle(element).backgroundImage;
                const imgUrl = bgImg.slice(4, -1).replace(/"/g, '');
                const img = new Image();
                img.removeEventListener('load', ()=>{});
                img.addEventListener('load', ()=>{
                    img.remove();
                    element.style.backgroundImage = `url(${imgUrl}) !important`;
                    fadedAfterLoad(element);
                });
                img.src = imgUrl;
            }
        };
        const addImgLoadCheck = (element, loadEl, src, srcset)=>{
            // console.log('addImgLoadCheck', {element}, {loadEl});
            // remove leading and ending spaces, and decode the url
            src = src.trim();
            src = decodeURIComponent(src);
            if (src == decodeURIComponent(loadEl.src)) return;
            this.resetLoaderElement(element);
            loadEl.removeEventListener('load', ()=>{});
            loadEl.addEventListener('load', ()=>{
                fadedAfterLoad(element);
            });
            element.classList.add('fader--loading');
            loadEl.src = src;
            if (srcset) {
                // remove leading and ending spaces, and decode the url
                srcset = srcset.trim();
                srcset = decodeURIComponent(srcset);
                loadEl.srcset = srcset;
            }
        };
        const addVideoAudioLoadCheck = (element, loadEl, src)=>{
            // console.log('addVideoAudioLoadCheck', {element}, {loadEl});
            // remove leading and ending spaces, and decode the url
            src = src.trim();
            src = decodeURIComponent(src);
            if (src == loadEl.src) return;
            // all video's play to load
            // couldn't do from loadeddata event, because play sometimes starts after that and pause wouldn't work
            loadEl.removeEventListener('play', ()=>{});
            loadEl.addEventListener('play', ()=>{
                // console.log('playing', event, loadEl.dataset.mayplay);
                if (isTouch && loadEl.dataset.autoplay === 'false' && loadEl.dataset.mayplay !== 'true') // in new frame because pause would sometimes not work
                requestAnimationFrame(()=>{
                    loadEl.autoplay = false;
                    loadEl.pause();
                    loadEl.currentTime = 0;
                    // only do this once, from initial play event used to load video
                    loadEl.dataset.mayplay = 'true';
                });
                if (loadEl.getAttribute('data-muted') === 'false') loadEl.muted = false;
            });
            loadEl.removeEventListener('loadeddata', ()=>{});
            loadEl.addEventListener('loadeddata', ()=>{
                fadedAfterLoad(element);
            });
            const autoplay = loadEl.getAttribute('data-autoplay');
            if (isTouch && !autoplay) {
                if (loadEl.muted === false) {
                    loadEl.setAttribute('data-muted', 'false');
                    loadEl.muted = true;
                } else loadEl.setAttribute('data-muted', 'true');
                if (loadEl.autoplay === false) {
                    loadEl.setAttribute('data-autoplay', 'false');
                    loadEl.autoplay = true;
                } else loadEl.setAttribute('data-autoplay', 'true');
            }
            this.resetLoaderElement(element);
            loadEl.src = src;
        };
        const fadedAfterLoad = (element)=>{
            // console.log('fadedAfterLoad', {element});
            // you need all 3 to stop calling loadElement
            element.classList.remove('fader--loading');
            element.classList.remove('fader--loader');
            element.classList.remove('fader--lazy');
            element.classList.add('fader--loaded');
            // remember it's loaded
            const dataClass = element.getAttribute('data-class');
            if (dataClass.indexOf('fader--loaded') === -1) element.setAttribute('data-class', dataClass + ' fader--loaded');
            fadeTimeout();
            const duration = element.classList.contains('fader--fast-load') ? fastLoadDuration : this.fadeDur;
            setTimeout(()=>{
                element.dataset.fadeFromLoad = true;
                tryRemoveFaderProperties(element);
            }, parseInt(element.getAttribute('data-delay'), 10) + duration + this.preFadeResizeDur);
        };
        const fadeTimeout = ()=>{
            // console.log('fadeTimeout');
            // resize after certain amount of time, when elements have resized
            // by default this is 100ms
            clearTimeout(fadeBlocksTimeout);
            fadeBlocksTimeout = setTimeout(()=>{
                // console.log('fadeTimeout fadeBlocks');
                this.fadeBlocks(document.body);
                if (this.fadeScrollersSelector !== '') {
                    const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
                    fadeScrollers.forEach((element)=>{
                        this.fadeBlocks(element);
                    });
                }
                // call after load function
                if (this.afterLoadFunction) this.afterLoadFunction();
            }, this.preFadeResizeDur);
        };
        const scrollHandler = (event)=>{
            this.fadeBlocks(event.target);
        };
        const getPos = (element)=>{
            // calculate positions without transform
            const rect = element.getBoundingClientRect();
            let { top: top } = rect;
            let { bottom: bottom } = rect;
            if (element.classList.contains('fader')) {
                if (element.classList.contains('fader--up')) {
                    // is transformed 100%, so add element height
                    top -= rect.height;
                    bottom += rect.height;
                } else if (element.classList.contains('fader--left') || element.classList.contains('fader--right')) ;
                else {
                    // is transformed, so add vert
                    top += vert;
                    bottom -= vert;
                }
            }
            // console.log('getTop', {top}, {bottom}, {fold});
            return {
                top: top,
                bottom: bottom
            };
        };
        this.fadeBlocks = (scrollEl)=>{
            // console.log('fadeBlocks', {scrollEl, vert});
            let doSetFaders = false;
            // fade in the blocks when scrolling
            const faderElements = scrollEl.querySelectorAll('.fader2');
            faderElements.forEach((element, index)=>{
                // console.log(element.classList[0]);
                if (!element.classList.contains('fader') && !element.classList.contains('fader--repeat')) return;
                // if invisible, don't fade
                const position = window.getComputedStyle(element).getPropertyValue('position');
                if (element.offsetParent === null && position !== 'fixed') return;
                const pos = getPos(element);
                // lazy load images before they are visible
                if (element.classList.contains('fader--lazy') && (pos.top < lazyFold || this.fadeBelowFold)) // console.log('lazy load', {element});
                loadElement(element);
                // console.log(element.classlist[0], {top}, {bottom}, {fold}, element.dataset.faded);
                if (pos.top < fold && !element.classList.contains('fader--top') // only from bottom
                 || pos.top < fold && pos.bottom > 0 && element.classList.contains('fader--top') // from top and bottom
                 || this.fadeBelowFold || element.classList.contains('fader--below-fold')) {
                    if (element.dataset.faded) return;
                    // console.log('fade from scroll: ', {element, top}, element.classList[0]);
                    // only do this once
                    element.dataset.faded = 'true';
                    // console.log(element.classList[0], fadersAnimating);
                    if (element.classList.contains('fader--no-fade')) {
                        // non-fading element
                        element.classList.add('fader3'); // visible
                        element.dataset.fadeFromScroll = 'true';
                        tryRemoveFaderProperties(element);
                    } else {
                        // console.log('fade element: ', element);
                        // fading element
                        // add a delayed animation for the animating blocks
                        let extraDelay;
                        let delay;
                        if (element.classList.contains('fader--fast-load')) {
                            extraDelay = 0;
                            delay = 0;
                        } else {
                            extraDelay = element.dataset.faderDelay ? parseInt(element.dataset.faderDelay, 10) : '';
                            if (this.addStaggerToFaderDelay || extraDelay === '') {
                                if (extraDelay == '') extraDelay = 0;
                                // add data-fader-delay to stagger
                                delay = this.stagger * fadersAnimating + this.preFadeResizeDur + extraDelay;
                                // remember total fading blocks, to get them to not animate at the same time
                                if (!element.classList.contains('fader--no-stagger') && !element.classList.contains('fader--fast-load')) fadersAnimating++;
                            } else // use only data-fader-delay
                            // doesn't update fadersAnimating, because the delay duration might not align with the default stagger
                            delay = extraDelay;
                        }
                        // console.log(element.classList[0], {delay});
                        element.style.transitionDelay = delay + 'ms';
                        element.setAttribute('data-delay', delay); // remember delay for loading media
                        element.classList.add('fader3'); // fade in
                        // maxFades so you don't have to wait too long when scrolling down fast
                        if (fadersAnimating > this.maxFades) fadersAnimating = this.maxFades;
                        // remove stagger
                        setTimeout(()=>{
                            // console.log('start ani');
                            fadersAnimating--;
                            if (fadersAnimating < 0) fadersAnimating = 0;
                        }, delay);
                        const duration = element.classList.contains('fader--fast-load') ? fastLoadDuration : this.fadeDur;
                        // console.log('fade from scroll', element.classList[0], {duration}, {delay}, {fadersAnimating});
                        // console.log({duration, delay});
                        // to prevent multiple setTimeout calls
                        // this can happen when fadeAgain is called
                        const random = Math.random().toString(36).substring(2, 15);
                        element.dataset.initilizer = random;
                        // after fading in
                        setTimeout(()=>{
                            // if these are not the same, it means the element was faded again
                            // console.log(random, element.dataset.initilizer);
                            if (random !== element.dataset.initilizer) return;
                            element.dataset.fadeFromScroll = 'true';
                            tryRemoveFaderProperties(element);
                        }, duration + delay);
                    }
                } else if (element.classList.contains('fader--repeat') && element.dataset.faded) {
                    // check faded so it's only reset after having faded
                    // this is a faded repeat element below bottom, or above top fold
                    // console.log('above or below fold, fade again', index);
                    // set new random, so code in timeout is not executed after going out of view
                    const random = Math.random().toString(36).substring(2, 15);
                    element.dataset.initilizer = random;
                    fadeAgain(element); // adds fader class at the end
                    doSetFaders = true;
                }
            });
            if (doSetFaders) this.setFaders();
        };
        this.fadeInHolderAgain = (holderSelector)=>{
            // console.log('fadeInHolderAgain', holderSelector);
            // get all faders from holder
            const holder = document.querySelector(holderSelector);
            const elements = holder.querySelectorAll('.fader2');
            elements.forEach(fadeAgain);
            this.setFaders();
        };
        this.fadeElementsAgain = (selector)=>{
            // console.log('fadeElementsAgain', selector);
            const elements = document.querySelectorAll(selector);
            elements.forEach(fadeAgain);
            this.setFaders();
        };
        const fadeAgain = (element)=>{
            // console.log('fadeAgain', element.classList[0]);
            tryRemoveFaderProperties(element, true); // true = force remove fader properties
            element.dataset.faded = '';
            element.dataset.fadeFromScroll = '';
            // element.dataset.fadeFromLoad = ''; // don't reset fade from load, because it might be loaded
            element.setAttribute('class', element.getAttribute('data-class')); // reset class attr
        };
        const tryRemoveFaderProperties = (element, force = false)=>{
            // console.log('tryRemoveFaderProperties', 'loaded: ' + element.dataset.fadeFromLoad, 'scrolled: ' + element.dataset.fadeFromScroll, element.classList[0], {force});
            // if faded from scroll and loaded
            // if faded from scroll and not loading
            // if faded from load and scrolling isn't relevant
            if (element.dataset.fadeFromScroll && element.dataset.fadeFromLoad || element.dataset.fadeFromScroll && !element.classList.contains('fader--loader') && !element.classList.contains('fader--loading') && !element.classList.contains('fader--loaded') || element.dataset.fadeFromLoad && element.classList.contains('fader--no-scroll') || force) {
                // console.log('remove fader properties', element.classList[0]);
                const defaultClassesToRemove = [
                    'fader',
                    'fader3',
                    'fader--no-scroll',
                    'fader--still',
                    'fader--no-fade',
                    'fader--clip',
                    'fader--no-stagger',
                    'fader--left',
                    'fader--right',
                    'fader--bl',
                    'fader--br',
                    'fader--shrink',
                    'fader--lazy',
                    'fader--top-start',
                    'fader--up',
                    'fader--fast-load'
                ];
                for(let i = 0; i < defaultClassesToRemove.length; i++)element.classList.remove(defaultClassesToRemove[i]);
                for(let i = 0; i < this.classesToRemove.length; i++)element.classList.remove(this.classesToRemove[i]);
                if (element.dataset.forceDelay) {
                    element.dataset.forceDelay = '';
                    // remove previously added delay for forced items
                    let resetDelay = parseInt(element.dataset.faderDelay, 10) - this.forceDelay;
                    if (resetDelay < 1) resetDelay = '';
                    element.dataset.faderDelay = resetDelay;
                }
                element.removeAttribute('data-delay');
                // leave fader--loaded and fader2 class because they're used elsewhere
                element.style.transitionDelay = '';
            }
        };
        // check for resizing of holders --------------------------------
        const observerResize = ()=>{
            // console.log('observerResize', this.blockResizeObserver, {windowWidth}, {prevObserverWidth}, {windowHeight}, {prevObserverHeight});
            // observed a resize but browser did not resize, this means content changed, so call setResize
            if (windowWidth == prevObserverWidth && windowHeight == prevObserverHeight && prevObserverWidth != 0 && prevObserverHeight != 0) {
                if (!this.blockResizeObserver) this.setFaders();
            }
            prevObserverWidth = windowWidth;
            prevObserverHeight = windowHeight;
        };
        const observerHandler = ()=>{
            // after possible site specific resize calculations
            if (!this.blockResizeObserver) setTimeout(observerResize, 100);
        };
        window.addEventListener('load', fadeTimeout);
        document.addEventListener('scroll', scrollHandler);
        window.addEventListener('resize', ()=>{
            // after possible site specific resize calculations
            setTimeout(this.setFaders, 100);
        });
        // add an observer, so the resizer is called when body size changes
        const el = document.querySelector('body');
        new ResizeObserver(observerHandler).observe(el);
        // create fader el to calculate vertical offset --------------------------------
        let vert = 0;
        const faderEl = document.createElement('div');
        document.body.insertBefore(faderEl, document.body.firstChild);
        // remove fade from elements in view on load --------------------------------
        if (this.skipOnLoadInView) {
            const faderEls = document.querySelectorAll('.fader');
            // console.log('skipOnLoadInView', {faderEls});
            let forceTotal = 0;
            faderEls.forEach((faderEl)=>{
                const pos = getPos(faderEl);
                if (pos.top < fold && pos.bottom > 0) {
                    // faderEl is in view
                    if (faderEl.classList.contains('fader--force')) {
                        // add delay for forced items (so they fade after view transition)
                        let delay = this.forceDelay;
                        // get original data-fader-delay
                        if (faderEl.dataset.faderDelay) // console.log(faderEl.classList[0], 'hasFaderDelay');
                        delay += parseInt(faderEl.dataset.faderDelay, 10);
                        else if (!this.addStaggerToFaderDelay) {
                            // add own stagger, because if isn't added in fadeBlocks, because this element will have a faderDelay
                            delay += forceTotal * this.stagger;
                            forceTotal++;
                        }
                        faderEl.dataset.faderDelay = delay;
                        faderEl.dataset.forceDelay = true;
                    } else // fade is not forced and element is in view on load, so skip fade
                    if (faderEl.classList.contains('fader--loader')) // faderEl needs loading, so still do fade but faster
                    faderEl.classList.add('fader--fast-load');
                    else {
                        // faderEl doesn't need loading, so skip fade
                        if (!faderEl.getAttribute('data-class')) faderEl.setAttribute('data-class', faderEl.getAttribute('class'));
                        // console.log(faderEl.classList, 'skip fade');
                        faderEl.classList.add('fader2');
                        faderEl.dataset.fadeFromScroll = 'true';
                        tryRemoveFaderProperties(faderEl);
                    }
                }
            });
        }
        // start using fader elements
        // console.log({fadeOnInit});
        if (this.fadeOnInit) this.setFaders();
    }
}



var $41264c54ad2c6427$exports = {};

$parcel$export($41264c54ad2c6427$exports, "windowWidth", () => $41264c54ad2c6427$export$c99e242bffb864af);
$parcel$export($41264c54ad2c6427$exports, "windowInnerWidth", () => $41264c54ad2c6427$export$c2f81cb82ec2bad8);
$parcel$export($41264c54ad2c6427$exports, "windowHeight", () => $41264c54ad2c6427$export$83c62512efb68338);
$parcel$export($41264c54ad2c6427$exports, "windowInnerHeight", () => $41264c54ad2c6427$export$5a628068c28e339f);
$parcel$export($41264c54ad2c6427$exports, "viewportHeight", () => $41264c54ad2c6427$export$b5aee153f48e3586);
$parcel$export($41264c54ad2c6427$exports, "fullTouch", () => $41264c54ad2c6427$export$f3ad53fe9668839f);
$parcel$export($41264c54ad2c6427$exports, "navbarHeight", () => $41264c54ad2c6427$export$95704ce82a7378af);
$parcel$export($41264c54ad2c6427$exports, "navbarPresent", () => $41264c54ad2c6427$export$a0f5451bfdace5c4);
$parcel$export($41264c54ad2c6427$exports, "navbarCurrentHeight", () => $41264c54ad2c6427$export$d9a4610da62f362e);
$parcel$export($41264c54ad2c6427$exports, "documentWidth", () => $41264c54ad2c6427$export$b3948ff9ea48227b);
$parcel$export($41264c54ad2c6427$exports, "documentHeight", () => $41264c54ad2c6427$export$47e578be7ea7065c);
$parcel$export($41264c54ad2c6427$exports, "maxBodyScrollTop", () => $41264c54ad2c6427$export$6d541604d001cc1d);
$parcel$export($41264c54ad2c6427$exports, "maxBodyScrollLeft", () => $41264c54ad2c6427$export$90901bcb70c82302);
$parcel$export($41264c54ad2c6427$exports, "blockResizeObserver", () => $41264c54ad2c6427$export$104dfeb21e8f6f17);
$parcel$export($41264c54ad2c6427$exports, "navHeight", () => $41264c54ad2c6427$export$ce1b01526c7798c2);
$parcel$export($41264c54ad2c6427$exports, "setBlockResizeObserver", () => $41264c54ad2c6427$export$6e2267417cad2903);
$parcel$export($41264c54ad2c6427$exports, "initResize", () => $41264c54ad2c6427$export$1a8cec7304e4a7df);
$parcel$export($41264c54ad2c6427$exports, "setResize", () => $41264c54ad2c6427$export$1871afb4a41ded14);
$parcel$export($41264c54ad2c6427$exports, "saveOffsets", () => $41264c54ad2c6427$export$11d57d7ff6599491);
// everything related to resizing, viewport, window, document, elements
// imports --------------------------------------------------------------------


var $b5ee8e0943d4762a$exports = {};

$parcel$export($b5ee8e0943d4762a$exports, "scrollTop", () => $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9);
$parcel$export($b5ee8e0943d4762a$exports, "scrollLeft", () => $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80);
$parcel$export($b5ee8e0943d4762a$exports, "windowBottom", () => $b5ee8e0943d4762a$export$3cebd429ba9c7e2f);
$parcel$export($b5ee8e0943d4762a$exports, "windowRight", () => $b5ee8e0943d4762a$export$fa1dcc62260e390a);
$parcel$export($b5ee8e0943d4762a$exports, "atBodyBottom", () => $b5ee8e0943d4762a$export$186a1a0a62ca04b8);
$parcel$export($b5ee8e0943d4762a$exports, "atBodyRight", () => $b5ee8e0943d4762a$export$5f2810376f156045);
$parcel$export($b5ee8e0943d4762a$exports, "isScrolling", () => $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2);
$parcel$export($b5ee8e0943d4762a$exports, "initScroll", () => $b5ee8e0943d4762a$export$44e7c48d94f0a708);
$parcel$export($b5ee8e0943d4762a$exports, "setScroll", () => $b5ee8e0943d4762a$export$6bbf62f168c1dddc);
$parcel$export($b5ee8e0943d4762a$exports, "checkBlockScroll", () => $b5ee8e0943d4762a$export$172c67b7e113cff8);
$parcel$export($b5ee8e0943d4762a$exports, "scrollToEl", () => $b5ee8e0943d4762a$export$9e22b9da3b459613);
$parcel$export($b5ee8e0943d4762a$exports, "animateScrollTop", () => $b5ee8e0943d4762a$export$af6768dd989e6334);
$parcel$export($b5ee8e0943d4762a$exports, "animateScrollLeft", () => $b5ee8e0943d4762a$export$5424b0e2a0d99a6c);
// scroll functions and listeners
// imports --------------------------------------------------------------------



let $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 = 0;
let $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 = 0;
let $b5ee8e0943d4762a$export$3cebd429ba9c7e2f = window.innerHeight;
let $b5ee8e0943d4762a$export$fa1dcc62260e390a = window.innerWidth;
let $b5ee8e0943d4762a$export$186a1a0a62ca04b8 = false;
let $b5ee8e0943d4762a$export$5f2810376f156045 = false;
let $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = false;
// local variables ------------------------------------------------------------
let $b5ee8e0943d4762a$var$scrollDuration = 35; // default = 35
const $b5ee8e0943d4762a$var$headerEl = document.querySelector('.header');
const $b5ee8e0943d4762a$export$44e7c48d94f0a708 = ()=>{
    // scroll listener
    window.addEventListener('scroll', $b5ee8e0943d4762a$export$6bbf62f168c1dddc, {
        passive: true
    });
};
const $b5ee8e0943d4762a$export$6bbf62f168c1dddc = ()=>{
    // do scrolling actions
    // console.log('setScroll');
    if ('fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined') {
        if ($56a526a578fe3239$exports.fixer.bodyFixed !== true) $b5ee8e0943d4762a$var$updateFromScroll();
    } else $b5ee8e0943d4762a$var$updateFromScroll();
};
const $b5ee8e0943d4762a$var$updateFromScroll = ()=>{
    $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 = window.scrollY || document.documentElement.scrollTop;
    $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 = window.scrollX || document.documentElement.scrollLeft;
    $b5ee8e0943d4762a$export$3cebd429ba9c7e2f = $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 + window.innerHeight;
    $b5ee8e0943d4762a$export$fa1dcc62260e390a = $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 + window.innerWidth;
    // use >= becaues of ios scrolling past the max, -1 for smooth scroll
    $b5ee8e0943d4762a$export$186a1a0a62ca04b8 = $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 >= $41264c54ad2c6427$exports.maxBodyScrollTop - 1;
    $b5ee8e0943d4762a$export$5f2810376f156045 = $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 >= $41264c54ad2c6427$exports.maxBodyScrollLeft - 1;
    // console.log('updateFromScroll', {scrollTop, scrollLeft, windowBottom, windowRight, atBodyBottom, atBodyRight});
    if ($b5ee8e0943d4762a$var$headerEl && $pageType === 'project') {
        const status = $b5ee8e0943d4762a$var$headerEl.dataset.status;
        if ($b5ee8e0943d4762a$var$headerEl.dataset.status === 'returning') return;
        const backwardEl = document.querySelector('.header__logo-video--backward');
        const forwardEl = document.querySelector('.header__logo-video--forward');
        if ($b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 > 10) {
            if ($b5ee8e0943d4762a$var$headerEl.dataset.status !== 'forward') {
                // console.log('forward');
                $b5ee8e0943d4762a$var$headerEl.dataset.status = 'forward';
                if (forwardEl) {
                    forwardEl.currentTime = 0;
                    forwardEl.play();
                }
                // hidden
                if (backwardEl) {
                    backwardEl.currentTime = 0;
                    backwardEl.pause();
                }
            }
        } else if ($b5ee8e0943d4762a$var$headerEl.dataset.status === 'forward') {
            // console.log('backward');
            $b5ee8e0943d4762a$var$headerEl.dataset.status = 'backward';
            if (backwardEl) {
                backwardEl.currentTime = 0;
                backwardEl.play();
            }
            // hidden
            if (forwardEl) {
                forwardEl.currentTime = 0;
                forwardEl.pause();
            }
        }
    }
// switch ($pageType) {
//
// }
};
const $b5ee8e0943d4762a$export$172c67b7e113cff8 = ()=>{
    // console.log('checkBlockScroll');
    const hasFixer = 'fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined';
    const hasAnimator = 'animator' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.animator?.disableSmoothScroll !== 'undefined';
    if (document.querySelector('.popover--active, .body--nav, .media--fullscreen')) {
        if (hasFixer) $56a526a578fe3239$exports.fixer.fixBody();
        if (hasAnimator) $56a526a578fe3239$exports.animator.disableSmoothScroll();
    } else {
        if (hasFixer) $56a526a578fe3239$exports.fixer.unfixBody();
        if (hasAnimator && !$b5ee8e0943d4762a$export$3db4e7cb4a7afaa2) $56a526a578fe3239$exports.animator.enableSmoothScroll();
        if ('saveOffsets' in $41264c54ad2c6427$exports) $41264c54ad2c6427$exports.saveOffsets();
    }
};
const $b5ee8e0943d4762a$export$9e22b9da3b459613 = (el, returnFunction = '', offset = $41264c54ad2c6427$exports.navHeight)=>{
    const rect = el.getBoundingClientRect();
    const top = rect.top + $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 - offset;
    $b5ee8e0943d4762a$export$af6768dd989e6334(top, document.body, returnFunction);
};
const $b5ee8e0943d4762a$export$af6768dd989e6334 = (scroll, element = document.body, returnFunction = '', useMax = true)=>{
    // console.log('animateScrollTop', {scroll}, {element}, {returnFunction}, {useMax});
    let height;
    let scrollHeight;
    if (element.tagName === 'BODY') {
        height = window.innerHeight;
        scrollHeight = document.documentElement.scrollHeight;
        if ('animator' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.animator.disableSmoothScroll();
    } else {
        // not body
        height = element.offsetHeight;
        scrollHeight = element.scrollHeight;
    }
    if (useMax) {
        // maxscroll is where the scroll reaches the bottom
        // don't go past that or the animation will not be smooth
        const maxScroll = scrollHeight - height;
        if (scroll > maxScroll) scroll = maxScroll;
        if (scroll < 0) scroll = 0;
    }
    // needs to change for body because of browser differences
    if (element.tagName === 'BODY') element = document.documentElement;
    // console.log({height}, {scroll});
    $b5ee8e0943d4762a$var$scrollToPosition(scroll, 'top', element, returnFunction);
};
const $b5ee8e0943d4762a$export$5424b0e2a0d99a6c = (scroll, element = document.body, returnFunction = '', useMax = true)=>{
    // console.log('animateScrollLeft', {scroll}, {element}, {returnFunction}, {useMax});
    let width;
    let scrollWidth;
    if (element.tagName === 'BODY') {
        width = window.innerWidth;
        scrollWidth = document.documentElement.scrollWidth;
    } else {
        // not body
        width = element.offsetWidth;
        scrollWidth = element.scrollWidth;
    }
    if (useMax) {
        // maxscroll is where the scroll reaches the side
        const maxScroll = scrollWidth - width;
        if (scroll > maxScroll) scroll = maxScroll;
        if (scroll < 0) scroll = 0;
    }
    // needs to change for body because of browser differences
    if (element.tagName === 'BODY') element = document.documentElement;
    // console.log({width}, {scroll});
    $b5ee8e0943d4762a$var$scrollToPosition(scroll, 'left', element, returnFunction);
};
const $b5ee8e0943d4762a$var$scrollToPosition = (to, direction = 'top', element, returnFunction = '')=>{
    // get document scroll
    let start;
    if (element == document.documentElement) start = direction === 'top' ? window.scrollY || element.scrollTop : window.scrollX || element.scrollLeft;
    else start = direction === 'top' ? element.scrollTop : element.scrollLeft;
    const change = to - start;
    if (change < 1 && change > -1) {
        if (element == document.documentElement) $b5ee8e0943d4762a$export$172c67b7e113cff8();
        if (typeof returnFunction === 'function') returnFunction();
        return;
    }
    $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = true;
    let duration = Math.sqrt(Math.abs(change)) * $b5ee8e0943d4762a$var$scrollDuration;
    if (duration < 1600) duration = 1600;
    const increment = 15;
    let currentTime = 0;
    // console.log(element.tagName, {start, change, duration, increment, currentTime});
    const easeInOutQuart = (t)=>t < 0.5 ? 8 * t ** 4 : 1 - 8 * (--t * t ** 3);
    const animateScroll = ()=>{
        currentTime += increment;
        const val = easeInOutQuart(currentTime / duration);
        const currentScroll = start + change * val;
        if (direction === 'top') element.scrollTo({
            top: currentScroll
        });
        else element.scrollTo({
            left: currentScroll
        });
        if (currentTime < duration) setTimeout(animateScroll, increment);
        else {
            $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = false;
            if (element == document.documentElement) $b5ee8e0943d4762a$export$172c67b7e113cff8();
            if (typeof returnFunction === 'function') returnFunction();
        }
    };
    animateScroll();
};


let $41264c54ad2c6427$export$c99e242bffb864af = 0;
let $41264c54ad2c6427$export$c2f81cb82ec2bad8 = 0;
let $41264c54ad2c6427$export$83c62512efb68338 = 0;
let $41264c54ad2c6427$export$5a628068c28e339f = 0;
let $41264c54ad2c6427$export$b5aee153f48e3586 = 0;
let $41264c54ad2c6427$export$f3ad53fe9668839f = 0;
let $41264c54ad2c6427$export$95704ce82a7378af = 0;
let $41264c54ad2c6427$export$a0f5451bfdace5c4 = true;
let $41264c54ad2c6427$export$d9a4610da62f362e = 0;
let $41264c54ad2c6427$export$b3948ff9ea48227b = 0;
let $41264c54ad2c6427$export$47e578be7ea7065c = 0;
let $41264c54ad2c6427$export$6d541604d001cc1d = 0;
let $41264c54ad2c6427$export$90901bcb70c82302 = 0;
let $41264c54ad2c6427$export$104dfeb21e8f6f17 = false; // set to true during animations to not call setResize
let $41264c54ad2c6427$export$ce1b01526c7798c2;
function $41264c54ad2c6427$export$6e2267417cad2903(value) {
    $41264c54ad2c6427$export$104dfeb21e8f6f17 = value;
}
// local variables -------------------------------------------------------------
const $41264c54ad2c6427$var$rootStyle = document.documentElement.style;
const $41264c54ad2c6427$var$resizeHolders = [
    '.main',
    '.popover'
]; // comment to turn off resize observer
let $41264c54ad2c6427$var$prevInnerWidth = 0;
let $41264c54ad2c6427$var$prevObserverWidth = 0;
let $41264c54ad2c6427$var$prevObserverHeight = 0;
let $41264c54ad2c6427$var$footerTop;
let $41264c54ad2c6427$var$footerHeight;
let $41264c54ad2c6427$var$first = true;
const $41264c54ad2c6427$export$1a8cec7304e4a7df = ()=>{
    // visual viewport resize listener
    window.visualViewport.addEventListener('resize', $41264c54ad2c6427$export$1871afb4a41ded14);
    $183c77cc0773b3dc$export$dd32b77e25b56ab8.addEventListener('change', ()=>{
        setTimeout($41264c54ad2c6427$export$1871afb4a41ded14, 100);
    });
    // resize observer
    if (typeof $41264c54ad2c6427$var$resizeHolders !== 'undefined') for(let i = 0; i < $41264c54ad2c6427$var$resizeHolders.length; i++){
        // add an observer for each holder that resizes
        const observedEls = document.querySelectorAll($41264c54ad2c6427$var$resizeHolders[i]);
        observedEls.forEach((observedEl)=>{
            if (observedEl !== null) new ResizeObserver($41264c54ad2c6427$var$observerResize).observe(observedEl);
        });
    }
    // run once even if body is fixed
    $41264c54ad2c6427$var$doSaveOffsets();
};
const $41264c54ad2c6427$export$1871afb4a41ded14 = (force = false)=>{
    if (typeof force === 'object') force = false;
    // console.log('setResize', force);
    // do resizing actions
    const ftEl = document.querySelector('.full-touch');
    if (!ftEl) return;
    $41264c54ad2c6427$export$f3ad53fe9668839f = ftEl.offsetHeight; // height including navbar on touch
    $41264c54ad2c6427$export$5a628068c28e339f = window.innerHeight; // height minus current navbar on touch
    $41264c54ad2c6427$export$d9a4610da62f362e = $41264c54ad2c6427$export$f3ad53fe9668839f - $41264c54ad2c6427$export$5a628068c28e339f; // current navbar on touch
    if ($41264c54ad2c6427$var$first) $41264c54ad2c6427$export$95704ce82a7378af = $41264c54ad2c6427$export$d9a4610da62f362e; // navbar height
    $41264c54ad2c6427$var$first = false;
    $41264c54ad2c6427$export$83c62512efb68338 = $41264c54ad2c6427$export$f3ad53fe9668839f - $41264c54ad2c6427$export$95704ce82a7378af; // height minus navbar on touch
    $41264c54ad2c6427$export$c99e242bffb864af = document.documentElement.clientWidth; // width without scrollbar
    $41264c54ad2c6427$export$c2f81cb82ec2bad8 = window.innerWidth; // width with scrollbar
    $41264c54ad2c6427$export$b5aee153f48e3586 = window.visualViewport.height; // height minus current navbar and keyboard on touch
    $41264c54ad2c6427$export$a0f5451bfdace5c4 = $41264c54ad2c6427$export$5a628068c28e339f === $41264c54ad2c6427$export$83c62512efb68338 ? 1 : 0;
    $41264c54ad2c6427$var$rootStyle.setProperty('--window-width', $41264c54ad2c6427$export$c99e242bffb864af + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--window-height', $41264c54ad2c6427$export$83c62512efb68338 + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--inner-height', $41264c54ad2c6427$export$5a628068c28e339f + 'px'); // sometimes wrong on android
    $41264c54ad2c6427$var$rootStyle.setProperty('--viewport-height', $41264c54ad2c6427$export$b5aee153f48e3586 + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--navbar-height', $41264c54ad2c6427$export$95704ce82a7378af + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--current-navbar-height', $41264c54ad2c6427$export$d9a4610da62f362e + 'px');
    // on touch, if the body is fixed, menu is always present
    // so adding height: 100% is the way to add a correct size popover
    // or by setting height to windowHeight with js
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll(); // before resizing
    // when resizing width or height ---------------------------------------------
    // resize things
    // save sizes for css, use Rect because of subpixel values!!
    const navEl = document.querySelector('.nav');
    if (navEl) {
        $41264c54ad2c6427$export$ce1b01526c7798c2 = navEl.getBoundingClientRect().height;
        $41264c54ad2c6427$var$rootStyle.setProperty('--nav-height', $41264c54ad2c6427$export$ce1b01526c7798c2 + 'px');
    }
    const footerEl = document.querySelector('.footer');
    if (footerEl) {
        $41264c54ad2c6427$var$footerHeight = footerEl.getBoundingClientRect().height;
        $41264c54ad2c6427$var$rootStyle.setProperty('--footer-height', $41264c54ad2c6427$var$footerHeight + 'px');
    }
    // check if resize width or forced
    if ($41264c54ad2c6427$export$c2f81cb82ec2bad8 === $41264c54ad2c6427$var$prevInnerWidth && force === false) {
        $41264c54ad2c6427$export$11d57d7ff6599491();
        $b5ee8e0943d4762a$exports.setScroll();
        return;
    }
    $41264c54ad2c6427$var$prevInnerWidth = $41264c54ad2c6427$export$c2f81cb82ec2bad8;
    // from here is skipped when only resizing height ----------------------------
    // code...
    // last
    $41264c54ad2c6427$export$11d57d7ff6599491();
    $b5ee8e0943d4762a$exports.setScroll();
};
const $41264c54ad2c6427$export$11d57d7ff6599491 = ()=>{
    // console.log('saveOffsets');
    if ('fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined') {
        if ($56a526a578fe3239$exports.fixer.bodyFixed !== true) $41264c54ad2c6427$var$doSaveOffsets();
    } else $41264c54ad2c6427$var$doSaveOffsets();
};
const $41264c54ad2c6427$var$doSaveOffsets = ()=>{
    // console.log('doSaveOffsets'); 
    // always call this through saveOffsets
    // save offsets here
    $41264c54ad2c6427$export$47e578be7ea7065c = document.documentElement.scrollHeight; // entire document height
    $41264c54ad2c6427$export$6d541604d001cc1d = $41264c54ad2c6427$export$47e578be7ea7065c - $41264c54ad2c6427$export$5a628068c28e339f;
    $41264c54ad2c6427$var$rootStyle.setProperty('--document-height', $41264c54ad2c6427$export$47e578be7ea7065c + 'px');
    $41264c54ad2c6427$export$b3948ff9ea48227b = document.documentElement.scrollWidth; // entire document width
    $41264c54ad2c6427$export$90901bcb70c82302 = $41264c54ad2c6427$export$b3948ff9ea48227b - $41264c54ad2c6427$export$c99e242bffb864af;
// documentHeight based calculations
// code...
};
// helper functions ------------------------------------------------------------
// check for resizing of holders
const $41264c54ad2c6427$var$observerResize = ()=>{
    // console.log('observerResize', blockResizeObserver, windowWidth, prevObserverWidth, windowHeight, prevObserverHeight);
    // prevent double resize when resizing window
    if (($41264c54ad2c6427$export$c99e242bffb864af !== $41264c54ad2c6427$var$prevObserverWidth || $41264c54ad2c6427$export$83c62512efb68338 !== $41264c54ad2c6427$var$prevObserverHeight) && $41264c54ad2c6427$var$prevObserverWidth !== 0) {
        $41264c54ad2c6427$var$prevObserverWidth = $41264c54ad2c6427$export$c99e242bffb864af;
        $41264c54ad2c6427$var$prevObserverHeight = $41264c54ad2c6427$export$83c62512efb68338;
        return;
    }
    $41264c54ad2c6427$var$prevObserverWidth = $41264c54ad2c6427$export$c99e242bffb864af;
    $41264c54ad2c6427$var$prevObserverHeight = $41264c54ad2c6427$export$83c62512efb68338;
    // not animating? do resize
    if (!$41264c54ad2c6427$export$104dfeb21e8f6f17) $41264c54ad2c6427$export$1871afb4a41ded14(true);
};



let $56a526a578fe3239$export$760c9eb46059594c;
let $56a526a578fe3239$export$bba485742287c13f = sessionStorage.getItem('pageType');
document.body.setAttribute('data-pagetype-prev', $56a526a578fe3239$export$bba485742287c13f);
sessionStorage.setItem('pageType', $pageType);
// local variables ------------------------------------------------------------
const $56a526a578fe3239$var$browserColorEl = document.querySelector('.browser-color');
const $56a526a578fe3239$export$caa6e1ba6b757214 = ()=>{
    // console.log('once');
    // delay so fader classes are already given in page js on page load
    // can't be requestAnimationFrame because if you open in a new tab, there is no new frame
    setTimeout(()=>{
        // incorrent when using back buttons, because DOMcontentLoaded is fired before pagereveal
        // console.log('window.blPageTransition', window.blPageTransition); 
        // alert(window.blPageTransition ? 'Page transition' : 'No page transition');
        // add Fader
        $56a526a578fe3239$export$760c9eb46059594c = new (0, $0b34a3644a6f4c48$export$2e2bcd8739ae039)({
            fadeOnInit: false,
            // mobileMq: '(orientation: portrait)',
            fadeDur: 1200,
            // preFadeResizeDur: 200,
            // afterLoadFunction: Resize.saveOffsets, 
            skipOnLoadInView: window.blPageTransition
        });
    }, 0); // less than page js fader delay
    // save $pageType in sesstionStorage
    // output name for devvers ----------------------------------
    console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
    console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};
const $56a526a578fe3239$export$2f5ac5bcfd51f435 = ()=>{
    // console.log('observerBlocker');
    $41264c54ad2c6427$export$6e2267417cad2903(true);
    if (typeof $56a526a578fe3239$export$760c9eb46059594c !== 'undefined' && $56a526a578fe3239$export$760c9eb46059594c) $56a526a578fe3239$export$760c9eb46059594c.blockResizeObserver = true;
    if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = true;
};
const $56a526a578fe3239$export$5a0a8e9ff7c0e4a7 = ()=>{
    // console.log('observerUnblocker');  
    $41264c54ad2c6427$export$6e2267417cad2903(false);
    $41264c54ad2c6427$export$1871afb4a41ded14(true);
    if (typeof $56a526a578fe3239$export$760c9eb46059594c !== 'undefined' && $56a526a578fe3239$export$760c9eb46059594c) $56a526a578fe3239$export$760c9eb46059594c.blockResizeObserver = false;
    if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = false;
};
const $56a526a578fe3239$var$frameHandler = ()=>{
    // console.log('frameHandler');
    // browser color
    if ($56a526a578fe3239$var$browserColorEl) {
        const background = getComputedStyle($56a526a578fe3239$var$browserColorEl).getPropertyValue('background-color');
        document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
    }
};



let $592a2eb60fbd4a62$export$d6c7e16048971142 = false;
// local variables ------------------------------------------------------------
const $592a2eb60fbd4a62$var$headerEl = document.querySelector('.header');
const $592a2eb60fbd4a62$export$f699d83c57fc51d7 = ()=>{
    // console.log('listeners');
    // touch --------------------------------
    const hoverSelector = 'button, a, input';
    document.body.addEventListener('touchstart', (event)=>{
        // console.log('touchstart', event.target.classList[0]);
        // add touch hover classes
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f(hoverSelector, event);
        if (el) el.classList.add('hover');
    });
    document.body.addEventListener('touchend', (event)=>{
        // console.log('touchend', event.target.classList[0]);
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f(hoverSelector, event);
        if (el) el.classList.remove('hover');
    });
    // touch and mouse --------------------------------
    document.body.addEventListener('click', (event)=>{
        // console.log('click', event.target.classList[0]);
        // remove focus after click
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]', event);
        if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();
        el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.header__logo, .js-back', event);
        if (el) {
            event.preventDefault();
            if ($592a2eb60fbd4a62$var$headerEl && $592a2eb60fbd4a62$var$headerEl.dataset.status === 'forward') {
                $592a2eb60fbd4a62$var$headerEl.dataset.status = 'returning';
                const backwardEl = document.querySelector('.header__logo-video--backward');
                if (backwardEl) {
                    backwardEl.currentTime = 0;
                    backwardEl.play();
                }
                setTimeout($592a2eb60fbd4a62$var$gotoHome, 500);
            } else $592a2eb60fbd4a62$var$gotoHome();
        // Scroll.animateScrollTop(0, document.body, gotoHome);
        }
    });
    // keyboard --------------------------------
    document.body.addEventListener('keydown', (event)=>{
        // console.log('keydown', event.key);
        $592a2eb60fbd4a62$export$d6c7e16048971142 = true;
    });
    // mouse and keyboard --------------------------------
    // mouseout, focusout listeners 
    const outHandler = (event)=>{
        // use if (event.type === 'mouseout') to avoid keyboard blur
        if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
        if (event.type === 'focusout' && !$592a2eb60fbd4a62$export$d6c7e16048971142) return;
    // console.log('outHandler', event.target.classList[0], event.type);
    // let el = elFromEvent(swiperHoverSelector, event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }
    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }
    };
    // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
    document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
    document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button
    // mouseover, focusin listeners 
    const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
    const inHandler = (event)=>{
        // use if (event.type === 'mouseover') to avoid keyboard focus
        if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
        if (event.type === 'focusin' && !$592a2eb60fbd4a62$export$d6c7e16048971142) return;
        // console.log('inHandler', event.target.classList[0], event.type);
        // let el = elFromEvent(swiperHoverSelector, event);
        // if (el && Once.aim) {
        //   Once.aim.classList.add('animate-it-mouse--hover');
        // }
        // el = elFromEvent('.swiper-wrapper', event);
        // if (el && Once.aim) {
        //   Once.aim.classList.add('animate-it-mouse--drag-hor');
        // }
        // keyboard focus fixed footer, scroll there
        // if (event.type == 'focusin' && fromKeyboard && event.target.closest('.footer')) {
        //   Scroll.animateScrollTop(1000000);
        // }
        $592a2eb60fbd4a62$export$d6c7e16048971142 = false;
    };
    // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
    document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
    document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button
    // mousedown listener --------------------------------
    document.body.addEventListener('mousedown', (event)=>{
    // console.log('mousedown', event.target.classList[0]);
    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
    }, true);
    // mousemove listener --------------------------------
    document.body.addEventListener('mousemove', (event)=>{
        // console.log('mousemove', event.target.classList[0]);
        const x = event.clientX;
        const y = event.clientY;
    }, true);
    // mouseup listener --------------------------------
    document.body.addEventListener('mouseup', (event)=>{
    // console.log('mouseup', event.target.classList[0]);
    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
    }, true);
    // pagehide listener --------------------------------
    window.addEventListener('pagehide', (event)=>{
        // console.log('pagehide', event);
        // Place any cleanup or transition code here
        if ($592a2eb60fbd4a62$var$headerEl) {
            cl = $592a2eb60fbd4a62$var$headerEl.classList;
            cl.remove('header--mix');
            cl.remove('header--scrolling');
            cl.remove('header--scrolled');
        }
    });
};
// functions -------------------------------------------------------------------
const $592a2eb60fbd4a62$var$gotoHome = ()=>{
    if ($592a2eb60fbd4a62$var$headerEl) {
        cl = $592a2eb60fbd4a62$var$headerEl.classList;
        cl.remove('header--mix');
        cl.remove('header--scrolling');
        cl.remove('header--scrolled');
    }
    setTimeout(()=>{
        // no way to check if prev page was home, so we just redirect to home
        if ($pageType !== 'home') window.location.href = $baseUrl;
    }, 100);
};
const $592a2eb60fbd4a62$export$dad5d01df0fa2e2f = (selector, event)=>{
    // will return the element that matches the selector
    // returns for every sub element of the selector
    const { target: target } = event;
    const ancestor = target.closest(selector);
    return ancestor || target.matches(selector);
};



// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations
// imports --------------------------------------------------------------------
// import * as Cookies from './0-cookies-v3.1.js';



// media 1.6
// dependencies: can-autoplay.js
// depends on setPage() to call setMediaItems()
// depends on each $slick element to call setSlickVideo($slick)
// changelog
// 1.1 no $
// 1.2 supports audio now
// 1.3 supports fullscreen now
// 1.3.1 don't open embeds with preview when doing setPage, fix media class
// 1.3.2 new blockScrollchecker
// 1.3.3 fix for mistakenly hiding preview on touch
// 1.3.4 fix autoplay random pause
// 1.4 add set progress from progress bar
// 1.4.1 load main video with preview on play click
// 1.4.2 correct block scroll check and clean up
// 1.4.3 cleaner focusin/out
// 1.5 add fullscreen source support + remember time when switching sources
// 1.6 modular js
// imports --------------------------------------------------------------------




/* global Blob */ // This file is generated. Do not edit this file directly.
// Command: 'npm run generate' should be used to update the content.
/**
 * @type {Blob}
 */ var $f66167a3c26eb16f$var$AUDIO = new Blob([
    new Uint8Array([
        255,
        227,
        24,
        196,
        0,
        0,
        0,
        3,
        72,
        1,
        64,
        0,
        0,
        4,
        132,
        16,
        31,
        227,
        192,
        225,
        76,
        255,
        67,
        12,
        255,
        221,
        27,
        255,
        228,
        97,
        73,
        63,
        255,
        195,
        131,
        69,
        192,
        232,
        223,
        255,
        255,
        207,
        102,
        239,
        255,
        255,
        255,
        101,
        158,
        206,
        70,
        20,
        59,
        255,
        254,
        95,
        70,
        149,
        66,
        4,
        16,
        128,
        0,
        2,
        2,
        32,
        240,
        138,
        255,
        36,
        106,
        183,
        255,
        227,
        24,
        196,
        59,
        11,
        34,
        62,
        80,
        49,
        135,
        40,
        0,
        253,
        29,
        191,
        209,
        200,
        141,
        71,
        7,
        255,
        252,
        152,
        74,
        15,
        130,
        33,
        185,
        6,
        63,
        255,
        252,
        195,
        70,
        203,
        86,
        53,
        15,
        255,
        255,
        247,
        103,
        76,
        121,
        64,
        32,
        47,
        255,
        34,
        227,
        194,
        209,
        138,
        76,
        65,
        77,
        69,
        51,
        46,
        57,
        55,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        255,
        227,
        24,
        196,
        73,
        13,
        153,
        210,
        100,
        81,
        135,
        56,
        0,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170
    ])
], {
    type: 'audio/mpeg'
});
/**
 * @type {Blob}
 */ var $f66167a3c26eb16f$var$VIDEO = new Blob([
    new Uint8Array([
        0,
        0,
        0,
        28,
        102,
        116,
        121,
        112,
        105,
        115,
        111,
        109,
        0,
        0,
        2,
        0,
        105,
        115,
        111,
        109,
        105,
        115,
        111,
        50,
        109,
        112,
        52,
        49,
        0,
        0,
        0,
        8,
        102,
        114,
        101,
        101,
        0,
        0,
        2,
        239,
        109,
        100,
        97,
        116,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        128,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        0,
        0,
        2,
        194,
        109,
        111,
        111,
        118,
        0,
        0,
        0,
        108,
        109,
        118,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        232,
        0,
        0,
        0,
        47,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        1,
        236,
        116,
        114,
        97,
        107,
        0,
        0,
        0,
        92,
        116,
        107,
        104,
        100,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        101,
        100,
        116,
        115,
        0,
        0,
        0,
        28,
        101,
        108,
        115,
        116,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        100,
        109,
        100,
        105,
        97,
        0,
        0,
        0,
        32,
        109,
        100,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        8,
        0,
        85,
        196,
        0,
        0,
        0,
        0,
        0,
        45,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        115,
        111,
        117,
        110,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0,
        0,
        0,
        1,
        15,
        109,
        105,
        110,
        102,
        0,
        0,
        0,
        16,
        115,
        109,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        100,
        105,
        110,
        102,
        0,
        0,
        0,
        28,
        100,
        114,
        101,
        102,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        12,
        117,
        114,
        108,
        32,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        211,
        115,
        116,
        98,
        108,
        0,
        0,
        0,
        103,
        115,
        116,
        115,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        87,
        109,
        112,
        52,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        16,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        0,
        0,
        0,
        51,
        101,
        115,
        100,
        115,
        0,
        0,
        0,
        0,
        3,
        128,
        128,
        128,
        34,
        0,
        2,
        0,
        4,
        128,
        128,
        128,
        20,
        64,
        21,
        0,
        0,
        0,
        0,
        1,
        244,
        0,
        0,
        1,
        243,
        249,
        5,
        128,
        128,
        128,
        2,
        18,
        16,
        6,
        128,
        128,
        128,
        1,
        2,
        0,
        0,
        0,
        24,
        115,
        116,
        116,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        99,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        122,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        115,
        0,
        0,
        1,
        116,
        0,
        0,
        0,
        20,
        115,
        116,
        99,
        111,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        44,
        0,
        0,
        0,
        98,
        117,
        100,
        116,
        97,
        0,
        0,
        0,
        90,
        109,
        101,
        116,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        109,
        100,
        105,
        114,
        97,
        112,
        112,
        108,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45,
        105,
        108,
        115,
        116,
        0,
        0,
        0,
        37,
        169,
        116,
        111,
        111,
        0,
        0,
        0,
        29,
        100,
        97,
        116,
        97,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        76,
        97,
        118,
        102,
        53,
        54,
        46,
        52,
        48,
        46,
        49,
        48,
        49
    ])
], {
    type: 'video/mp4'
});
/* global URL */ function $f66167a3c26eb16f$var$setupDefaultValues(options) {
    return Object.assign({
        muted: false,
        timeout: 250,
        inline: false
    }, options);
}
function $f66167a3c26eb16f$var$startPlayback(_ref, elementCallback) {
    var muted = _ref.muted, timeout = _ref.timeout, inline = _ref.inline;
    var _elementCallback = elementCallback(), element = _elementCallback.element, source = _elementCallback.source;
    var playResult = void 0;
    var timeoutId = void 0;
    var sendOutput = void 0;
    element.muted = muted;
    if (muted === true) element.setAttribute('muted', 'muted');
    // indicates that the video is to be played "inline",
    // that is within the element's playback area.
    if (inline === true) element.setAttribute('playsinline', 'playsinline');
    element.src = source;
    return new Promise(function(resolve) {
        playResult = element.play();
        timeoutId = setTimeout(function() {
            sendOutput(false, new Error('Timeout ' + timeout + ' ms has been reached'));
        }, timeout);
        sendOutput = function sendOutput(result) {
            var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            // Clean up to avoid MediaElementLeak
            element.remove();
            element.srcObject = null;
            clearTimeout(timeoutId);
            resolve({
                result: result,
                error: error
            });
        };
        if (playResult !== undefined) playResult.then(function() {
            return sendOutput(true);
        }).catch(function(playError) {
            return sendOutput(false, playError);
        });
        else sendOutput(true);
    });
}
//
// API
//
function $f66167a3c26eb16f$var$video(options) {
    options = $f66167a3c26eb16f$var$setupDefaultValues(options);
    return $f66167a3c26eb16f$var$startPlayback(options, function() {
        return {
            element: document.createElement('video'),
            source: URL.createObjectURL($f66167a3c26eb16f$var$VIDEO)
        };
    });
}
function $f66167a3c26eb16f$var$audio(options) {
    options = $f66167a3c26eb16f$var$setupDefaultValues(options);
    return $f66167a3c26eb16f$var$startPlayback(options, function() {
        return {
            element: document.createElement('audio'),
            source: URL.createObjectURL($f66167a3c26eb16f$var$AUDIO)
        };
    });
}
var $f66167a3c26eb16f$var$index = {
    audio: $f66167a3c26eb16f$var$audio,
    video: $f66167a3c26eb16f$var$video
};
var $f66167a3c26eb16f$export$2e2bcd8739ae039 = $f66167a3c26eb16f$var$index;


// set user variables ----------------------------------------------------------
let $cb5bd9b497a92a8a$var$didPageInteraction = false;
const $cb5bd9b497a92a8a$var$showBlockedAutoplayHolderSelector = '.home'; // these will show OS play button
// set default variables -------------------------------------------------------
const $cb5bd9b497a92a8a$var$mediaSelector = '.media__video:not(.media__video--preview), .media__audio';
let $cb5bd9b497a92a8a$var$mediaTouchTimeout;
let $cb5bd9b497a92a8a$var$mediaDragging = false;
let $cb5bd9b497a92a8a$var$mediaDragEl;
const $cb5bd9b497a92a8a$export$4ea236338c7d64ed = ()=>{
    // click listener ------------------------------
    document.body.addEventListener('click', (event)=>{
        // autoplay video asap on mobile battery saver
        // touchstart doesn't count as interaction for unmuting
        // once
        if (!$cb5bd9b497a92a8a$var$didPageInteraction) {
            // actual autoplay videos, not ones that have autoplay from Fader.js
            const mediaVideoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"])');
            mediaVideoEls.forEach((mediaVideoEl)=>{
                mediaVideoEl.play();
                const mediaHolder = mediaVideoEl.closest('.media__holder');
                if (mediaHolder) mediaHolder.classList.remove('media__holder--hidden');
            });
            $cb5bd9b497a92a8a$var$didPageInteraction = true;
        }
        // tapped entire video
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media', event);
        if (el && $183c77cc0773b3dc$export$507ba88fae84526c) {
            // show controls on touch
            const mediaEl = el;
            mediaEl.classList.add('media--touched');
            clearTimeout($cb5bd9b497a92a8a$var$mediaTouchTimeout);
            $cb5bd9b497a92a8a$var$mediaTouchTimeout = setTimeout(()=>{
                mediaEl.classList.remove('media--touched');
            }, $183c77cc0773b3dc$export$34977f05af4bf228);
        }
        // click play/pause
        el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__btn--play-pause, .media__play', event);
        if (el) $cb5bd9b497a92a8a$export$4b6478966c109e99(el.closest('.media'));
        // click mute/unmute
        el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__btn--audio', event);
        if (el) {
            const mediaEl = el.closest('.media');
            const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
            if (mediaEl.classList.contains('media--muted')) {
                if (mediaMediaEl) mediaMediaEl.muted = false;
                mediaEl.classList.remove('media--muted');
            } else {
                // mute
                if (mediaMediaEl) mediaMediaEl.muted = true;
                mediaEl.classList.add('media--muted');
            }
        }
        // click grow/shrink
        el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__btn--fullscreen', event);
        if (el) {
            const mediaEl = el.closest('.media');
            if (!mediaEl) return;
            if (mediaEl.classList.contains('media--fullscreen')) $cb5bd9b497a92a8a$var$closeFullscreenMedia(mediaEl);
            else {
                mediaEl.classList.add('media--fullscreen');
                $cb5bd9b497a92a8a$var$setVideoFaderFS(mediaEl);
                if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
            }
        }
    });
    // mousedown listener ------------------------------
    document.addEventListener('mousedown', (event)=>{
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__progress', event);
        if (el) {
            $cb5bd9b497a92a8a$var$setMediaProgress(event, el, 'mouse');
            $cb5bd9b497a92a8a$var$mediaDragEl = el;
            $cb5bd9b497a92a8a$var$mediaDragging = true;
        }
    });
    // touchstart listener ------------------------------
    document.body.addEventListener('touchstart', (event)=>{
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__progress', event);
        if (el) {
            $cb5bd9b497a92a8a$var$setMediaProgress(event, el, 'touch');
            $cb5bd9b497a92a8a$var$mediaDragEl = el;
            $cb5bd9b497a92a8a$var$mediaDragging = true;
        }
    });
    // mousemove listener ------------------------------
    document.addEventListener('mousemove', (event)=>{
        if ($cb5bd9b497a92a8a$var$mediaDragging) $cb5bd9b497a92a8a$var$setMediaProgress(event, $cb5bd9b497a92a8a$var$mediaDragEl, 'mouse');
    });
    // touchmove listener ------------------------------
    document.body.addEventListener('touchmove', (event)=>{
        if ($cb5bd9b497a92a8a$var$mediaDragging) $cb5bd9b497a92a8a$var$setMediaProgress(event, $cb5bd9b497a92a8a$var$mediaDragEl, 'touch');
    });
    // mouseup listener ------------------------------
    document.addEventListener('mouseup', (event)=>{
        $cb5bd9b497a92a8a$var$mediaDragging = false;
    });
    // touchend listener ------------------------------
    document.body.addEventListener('touchend', (event)=>{
        $cb5bd9b497a92a8a$var$mediaDragging = false;
    });
    // keyboard focus on media buttons ----------------
    document.body.addEventListener('focusin', (event)=>{
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__btn', event);
        if (el) {
            const mediaEl = el.closest('.media');
            if (mediaEl) mediaEl.classList.add('media--focus');
        }
    });
    // keyboard blur on media buttons ----------------
    document.body.addEventListener('focusout', (event)=>{
        let el = $592a2eb60fbd4a62$export$dad5d01df0fa2e2f('.media__btn', event);
        if (el) {
            const mediaEl = el.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--focus');
        }
    });
    document.addEventListener('keyup', (event)=>{
        const fsMediaEl = document.querySelector('.media--fullscreen');
        if (!fsMediaEl) return;
        if (event.code === 'Escape') $cb5bd9b497a92a8a$var$closeFullscreenMedia(fsMediaEl);
        else if (event.code === 'Space') $cb5bd9b497a92a8a$export$4b6478966c109e99(fsMediaEl);
    });
    document.addEventListener('keydown', (event)=>{
        // block keyboard scrolling on fullscreen media
        if (document.querySelector('.media--fullscreen')) {
            if ([
                'Space',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.code) > -1) event.preventDefault();
        }
    }, false);
};
const $cb5bd9b497a92a8a$export$74fd572b7937cf92 = ()=>{
    // console.log('setMediaItems');
    (0, $f66167a3c26eb16f$export$2e2bcd8739ae039).video({
        timeout: 1000,
        muted: true,
        inline: true
    }).then(({ result: result, error: error })=>{
        // console.log({result, didPageInteraction});
        // even on battery saver, after a page interaction you can always autoplay video
        if (!result && !$cb5bd9b497a92a8a$var$didPageInteraction && $183c77cc0773b3dc$export$507ba88fae84526c) {
            // can't autoplay video's, so hide them
            // actual autoplay video's, not ones that have autoplay from Fader.js
            const mediaVideoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"])');
            mediaVideoEls.forEach((mediaVideoEl)=>{
                // If the media__video element can't autoplay and is not in the noHideAutoplayHolder, hide it
                const showBlockedAutoplayHolder = mediaVideoEl.closest($cb5bd9b497a92a8a$var$showBlockedAutoplayHolderSelector);
                if (!showBlockedAutoplayHolder) {
                    const mediaHolder = mediaVideoEl.closest('.media__holder');
                    if (mediaHolder) mediaHolder.classList.add('media__holder--hidden');
                }
            });
        }
    });
    let mediaMediaEls = document.querySelectorAll('.media__video:not([autoplay]):not(.media__video--preview), .media__audio');
    // console.log({mediaMediaEls});
    // remove observer from elements first
    $cb5bd9b497a92a8a$var$mediaSrcObserver.disconnect();
    mediaMediaEls.forEach((mediaMediaEl)=>{
        $cb5bd9b497a92a8a$var$mediaSrcObserver.observe(mediaMediaEl, {
            attributes: true
        });
        // remove Listeners for possible re-init
        mediaMediaEl.removeEventListener('ended', (event)=>{});
        mediaMediaEl.removeEventListener('webkitendfullscreen', (event)=>{});
        mediaMediaEl.removeEventListener('play', (event)=>{});
        mediaMediaEl.removeEventListener('pause', (event)=>{});
        mediaMediaEl.removeEventListener('timeupdate', (event)=>{});
        mediaMediaEl.addEventListener('ended', (event)=>{
            // console.log('ended', {autoplay: event.currentTarget.autoplay});
            // doesn't fire on iOS (sometimes)
            $cb5bd9b497a92a8a$var$endedMedia(event.currentTarget.closest('.media'));
        });
        mediaMediaEl.addEventListener('webkitendfullscreen', (event)=>{
            // console.log('fullscreen');
            // This pauses the media, so do correct actions
            const mediaEl = event.currentTarget.closest('.media');
            $cb5bd9b497a92a8a$var$pauseMedia(mediaEl);
        });
        mediaMediaEl.addEventListener('play', (event)=>{
            // console.log('play');
            const mediaEl = event.currentTarget.closest('.media');
            if (mediaEl) {
                mediaEl.classList.add('media--playing');
                const mediaVideoEl = mediaEl.querySelector('.media__video');
                // console.log(mediaVideoEl.dataset.mayplay);
                if (mediaVideoEl && mediaVideoEl.dataset.mayplay === 'true') mediaEl.classList.add('media--started'); // hides preview
            }
        });
        mediaMediaEl.addEventListener('pause', (event)=>{
            // console.log('pause');
            const mediaEl = event.currentTarget.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--playing');
        });
    });
    // fix for random autoplay pausing
    mediaMediaEls = document.querySelectorAll('.media__video[autoplay]');
    mediaMediaEls.forEach((mediaMediaEl)=>{
        mediaMediaEl.addEventListener('pause', (event)=>{
            // console.log('pause autoplay');
            event.currentTarget.play();
        });
    });
    mediaMediaEls = document.querySelectorAll('.media__video:not(.media__video--preview), .media__audio');
    mediaMediaEls.forEach((mediaMediaEl)=>{
        mediaMediaEl.addEventListener('timeupdate', (event)=>{
            $cb5bd9b497a92a8a$var$showMediaTime(event.currentTarget);
        });
    });
    // in timeout not to interfere with the load event
    setTimeout(()=>{
        // open/play video's in the current selector
        if (typeof $historySelector === 'undefined') return;
        const historySelectorEl = document.querySelector($historySelector);
        if (historySelectorEl) {
            if (typeof openVideoEmbeds === 'function') openVideoEmbeds(historySelectorEl, false);
            $cb5bd9b497a92a8a$var$playAutoplayVideos(historySelectorEl);
        }
        // both skip foldouts
        let otherSelector;
        if ($historySelector == '.popover') otherSelector = '.main';
        else otherSelector = '.popover';
        // stop video's in the other selector
        const otherEl = document.querySelector(otherSelector);
        if (otherEl) {
            if (typeof closeVideoEmbeds === 'function') closeVideoEmbeds(otherEl);
            $cb5bd9b497a92a8a$var$pauseMediaItems(otherEl);
        }
    }, $183c77cc0773b3dc$export$35a4a76088200152);
};
// must be called when setting slick -------------------------------------------
// const setSlickVideo = $slickSlider => {
//   // pause other medias
//   $slickSlider.on('afterChange', (event, slick, currentSlide) => {
//     // console.log('afterChange');
//     const otherSlides = '.slick-slide:not([data-slick-index="' + currentSlide + '"])';
//     const $otherSlides = $(event.currentTarget).find(otherSlides);
//     $otherSlides.each((index, element) => {
//       const $media = $(element).find(mediaSelector);
//       // console.log({ $media });
//       $media.trigger('pause');
//       $(element).find('.media').removeClass('media--playing');
//     });
//   });
//   // if autoplay, continue current media
//   $slickSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//     const slide = '.slick-slide[data-slick-index="' + nextSlide + '"]';
//     const $currentSlide = $(event.currentTarget).find(slide);
//     const $media = $currentSlide.find(mediaSelector);
//     // console.log('beforeChange', { slide, $currentSlide, $media }, $media.prop('autoplay'));
//     if ($media.length && $media.prop('autoplay') === true) $media.trigger('play');
//     // media--playing doesn't get added for autoplay medias
//   });
// };
// functions -------------------------------------------------------------------
const $cb5bd9b497a92a8a$var$setMediaProgress = (event, progressEl, inputType)=>{
    const mediaEl = progressEl.closest('.media');
    if (!mediaEl) return;
    const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
    if (!mediaMediaEl) return;
    mediaEl.classList.add('media--started'); // hides preview
    let x;
    if (inputType == 'touch') x = event.touches[0].clientX - progressEl.getBoundingClientRect().left;
    else x = event.clientX - progressEl.getBoundingClientRect().left;
    const percentage = x / progressEl.offsetWidth * 100;
    mediaMediaEl.currentTime = mediaMediaEl.duration / 100 * percentage;
    $cb5bd9b497a92a8a$var$showMediaTime(mediaMediaEl, mediaMediaEl.currentTime);
    mediaEl.classList.add('media--touched');
    clearTimeout($cb5bd9b497a92a8a$var$mediaTouchTimeout);
    $cb5bd9b497a92a8a$var$mediaTouchTimeout = setTimeout(()=>{
        mediaEl.classList.remove('media--touched');
    }, $183c77cc0773b3dc$export$34977f05af4bf228);
};
const $cb5bd9b497a92a8a$var$closeFullscreenMedia = (mediaEl)=>{
    // hide holder, for safari fix
    // const zoomEl = mediaEl.closest('.zoom--active');
    // if (zoomEl) zoomEl.classList.remove('zoom--active');
    mediaEl.classList.remove('media--fullscreen');
    $cb5bd9b497a92a8a$var$setVideoFaderFS(mediaEl);
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
// show holder, for safari fix
// if (zoomEl) zoomEl.classList.add('zoom--active');
};
// load fullscreen video if available
const $cb5bd9b497a92a8a$var$setVideoFaderFS = (mediaEl)=>{
    if (!mediaEl) return;
    const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
    if (!mediaMediaEl) return;
    // this is the element that initialises the loading of a fullscreen source
    const mediaLoaderEl = mediaMediaEl.closest('.fader--loader, .fader--loading, .fader--loaded');
    if (mediaLoaderEl) {
        if (mediaEl.classList.contains('media--fullscreen')) mediaLoaderEl.classList.add('fader--fullscreen'); // removes transition so it remains fullscreen
        else mediaLoaderEl.classList.remove('fader--fullscreen');
        // begins possible load of fullscreen source
        if ('fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.setFaders();
    }
};
const $cb5bd9b497a92a8a$export$4b6478966c109e99 = (mediaEl)=>{
    if (!mediaEl) return;
    if (mediaEl.classList.contains('media--playing')) $cb5bd9b497a92a8a$var$pauseMedia(mediaEl);
    else {
        $cb5bd9b497a92a8a$var$pauseMediaItems(document.body);
        // audioBtnEls.forEach(audioBtnEl => audioBtnEl.classList.add('audio-btn--visible'));
        // end wilde weide
        // not playing, so play
        const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
        // console.log({mediaEl, mediaMediaEl});
        if (mediaMediaEl) {
            mediaMediaEl.dataset.mayplay = 'true'; // set mayplay so preview can fade
            if (!mediaMediaEl.src) {
                let classname = mediaMediaEl.getAttribute('class');
                classname += ' ' + mediaMediaEl.dataset.fader;
                mediaMediaEl.setAttribute('class', classname);
                if ('fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.setFaders();
            }
            mediaMediaEl.play();
        }
    }
};
const $cb5bd9b497a92a8a$var$showMediaTime = (mediaMediaEl, seconds = mediaMediaEl.currentTime)=>{
    // console.log('showMediaTime', {mediaMediaEl, seconds});
    if (!mediaMediaEl) return;
    // save current time for when switching sources
    if (seconds != 0) mediaMediaEl.dataset.seconds = seconds;
    let timeString;
    if (seconds < 3600) timeString = new Date(mediaMediaEl.currentTime * 1000).toISOString().slice(14, 19);
    else timeString = new Date(mediaMediaEl.currentTime * 1000).toISOString().slice(12, 19);
    const timeEl = mediaMediaEl.closest('.media').querySelector('.media__time');
    if (timeEl) timeEl.innerHTML = timeString;
    let percentage = seconds / mediaMediaEl.duration * 100;
    if (isNaN(percentage)) percentage = 0;
    const progressEl = mediaMediaEl.closest('.media').querySelector('.media__progress-bar');
    if (progressEl) progressEl.style.left = percentage + '%';
    if (mediaMediaEl.currentTime == mediaMediaEl.duration && seconds != 0) // media ended, but 'ended' doensn't fire on ios, so use this
    $cb5bd9b497a92a8a$var$endedMedia(mediaMediaEl.closest('.media'));
};
const $cb5bd9b497a92a8a$var$endedMedia = (mediaEl)=>{
    $cb5bd9b497a92a8a$var$pauseMedia(mediaEl);
    mediaEl.classList.remove('media--started');
    const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
    if (mediaMediaEl) mediaMediaEl.currentTime = 0;
};
const $cb5bd9b497a92a8a$var$pauseMedia = (mediaEl)=>{
    // console.log('pauseMedia', {mediaEl});
    const mediaMediaEl = mediaEl.querySelector($cb5bd9b497a92a8a$var$mediaSelector);
    if (mediaMediaEl) mediaMediaEl.pause();
// audioBtnEls.forEach(audioBtnEl => audioBtnEl.classList.remove('audio-btn--visible'));
};
const $cb5bd9b497a92a8a$var$playAutoplayVideos = (holderEl)=>{
    // console.log('playAutoplayVideos', holderEl);
    const mediaMediaEls = holderEl.querySelectorAll($cb5bd9b497a92a8a$var$mediaSelector);
    mediaMediaEls.forEach((mediaMediaEl)=>{
        // skips closed foldouts
        const foldout = mediaMediaEl.closest('.fold-out');
        // console.log({mediaMediaEl, foldout});
        if (mediaMediaEl.autoplay && (!foldout || foldout.classList.contains('fold-out--opened'))) mediaMediaEl.play();
    });
};
const $cb5bd9b497a92a8a$var$pauseMediaItems = (holderEl)=>{
    const mediaMediaEls = holderEl.querySelectorAll($cb5bd9b497a92a8a$var$mediaSelector);
    mediaMediaEls.forEach((mediaMediaEl)=>{
        const mediaEl = mediaMediaEl.closest('.media');
        if (mediaEl) $cb5bd9b497a92a8a$var$pauseMedia(mediaEl);
    });
};
const $cb5bd9b497a92a8a$var$mediaSrcObserver = new MutationObserver((mutations)=>{
    mutations.forEach((mutation)=>{
        if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
            // console.log('src changed to: ' + mutation.target.src);
            const mediaEl = mutation.target.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--playing');
            // set video with new source to the same time
            const mediaMediaEl = mutation.target;
            const { seconds: seconds } = mediaMediaEl.dataset;
            if (seconds) {
                mediaMediaEl.currentTime = seconds;
                $cb5bd9b497a92a8a$var$showMediaTime(mediaMediaEl, seconds);
            }
        }
    });
});


var $dc83030be8593b5f$exports = {};


/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'outlayer/outlayer',
        'get-size/get-size'
    ], factory);
    else if (0, $dc83030be8593b5f$exports) // CommonJS
    $dc83030be8593b5f$exports = factory((parcelRequire("ad2td")), (parcelRequire("g64Da")));
    else // browser global
    window1.Masonry = factory(window1.Outlayer, window1.getSize);
})(window, function factory(Outlayer, getSize) {
    'use strict';
    // -------------------------- masonryDefinition -------------------------- //
    // create an Outlayer layout class
    var Masonry = Outlayer.create('masonry');
    // isFitWidth -> fitWidth
    Masonry.compatOptions.fitWidth = 'isFitWidth';
    var proto = Masonry.prototype;
    proto._resetLayout = function() {
        this.getSize();
        this._getMeasurement('columnWidth', 'outerWidth');
        this._getMeasurement('gutter', 'outerWidth');
        this.measureColumns();
        // reset column Y
        this.colYs = [];
        for(var i = 0; i < this.cols; i++)this.colYs.push(0);
        this.maxY = 0;
        this.horizontalColIndex = 0;
    };
    proto.measureColumns = function() {
        this.getContainerWidth();
        // if columnWidth is 0, default to outerWidth of first item
        if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth || // if first elem has no width, default to size of container
            this.containerWidth;
        }
        var columnWidth = this.columnWidth += this.gutter;
        // calculate columns
        var containerWidth = this.containerWidth + this.gutter;
        var cols = containerWidth / columnWidth;
        // fix rounding errors, typically with gutters
        var excess = columnWidth - containerWidth % columnWidth;
        // if overshoot is less than a pixel, round up, otherwise floor it
        var mathMethod = excess && excess < 1 ? 'round' : 'floor';
        cols = Math[mathMethod](cols);
        this.cols = Math.max(cols, 1);
    };
    proto.getContainerWidth = function() {
        // container is parent if fit width
        var isFitWidth = this._getOption('fitWidth');
        var container = isFitWidth ? this.element.parentNode : this.element;
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var size = getSize(container);
        this.containerWidth = size && size.innerWidth;
    };
    proto._getItemLayoutPosition = function(item) {
        item.getSize();
        // how many columns does this brick span
        var remainder = item.size.outerWidth % this.columnWidth;
        var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
        // round if off by 1 pixel, otherwise use ceil
        var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
        colSpan = Math.min(colSpan, this.cols);
        // use horizontal or top column position
        var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
        var colPosition = this[colPosMethod](colSpan, item);
        // position the brick
        var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y
        };
        // apply setHeight to necessary columns
        var setHeight = colPosition.y + item.size.outerHeight;
        var setMax = colSpan + colPosition.col;
        for(var i = colPosition.col; i < setMax; i++)this.colYs[i] = setHeight;
        return position;
    };
    proto._getTopColPosition = function(colSpan) {
        var colGroup = this._getTopColGroup(colSpan);
        // get the minimum Y value from the columns
        var minimumY = Math.min.apply(Math, colGroup);
        return {
            col: colGroup.indexOf(minimumY),
            y: minimumY
        };
    };
    /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */ proto._getTopColGroup = function(colSpan) {
        if (colSpan < 2) // if brick spans only one column, use all the column Ys
        return this.colYs;
        var colGroup = [];
        // how many different places could this brick fit horizontally
        var groupCount = this.cols + 1 - colSpan;
        // for each group potential horizontal position
        for(var i = 0; i < groupCount; i++)colGroup[i] = this._getColGroupY(i, colSpan);
        return colGroup;
    };
    proto._getColGroupY = function(col, colSpan) {
        if (colSpan < 2) return this.colYs[col];
        // make an array of colY values for that one group
        var groupColYs = this.colYs.slice(col, col + colSpan);
        // and get the max value of the array
        return Math.max.apply(Math, groupColYs);
    };
    // get column position based on horizontal index. #873
    proto._getHorizontalColPosition = function(colSpan, item) {
        var col = this.horizontalColIndex % this.cols;
        var isOver = colSpan > 1 && col + colSpan > this.cols;
        // shift to next row if item can't fit on current row
        col = isOver ? 0 : col;
        // don't let zero-size items take up space
        var hasSize = item.size.outerWidth && item.size.outerHeight;
        this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
        return {
            col: col,
            y: this._getColGroupY(col, colSpan)
        };
    };
    proto._manageStamp = function(stamp) {
        var stampSize = getSize(stamp);
        var offset = this._getElementOffset(stamp);
        // get the columns that this stamp affects
        var isOriginLeft = this._getOption('originLeft');
        var firstX = isOriginLeft ? offset.left : offset.right;
        var lastX = firstX + stampSize.outerWidth;
        var firstCol = Math.floor(firstX / this.columnWidth);
        firstCol = Math.max(0, firstCol);
        var lastCol = Math.floor(lastX / this.columnWidth);
        // lastCol should not go over if multiple of columnWidth #425
        lastCol -= lastX % this.columnWidth ? 0 : 1;
        lastCol = Math.min(this.cols - 1, lastCol);
        // set colYs to bottom of the stamp
        var isOriginTop = this._getOption('originTop');
        var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
        for(var i = firstCol; i <= lastCol; i++)this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
    };
    proto._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var size = {
            height: this.maxY
        };
        if (this._getOption('fitWidth')) size.width = this._getContainerFitWidth();
        return size;
    };
    proto._getContainerFitWidth = function() {
        var unusedCols = 0;
        // count unused columns
        var i = this.cols;
        while(--i){
            if (this.colYs[i] !== 0) break;
            unusedCols++;
        }
        // fit container to columns that have been used
        return (this.cols - unusedCols) * this.columnWidth - this.gutter;
    };
    proto.needsResizeLayout = function() {
        var previousWidth = this.containerWidth;
        this.getContainerWidth();
        return previousWidth != this.containerWidth;
    };
    return Masonry;
});


// exported variables ---------------------------------------------------------
// local variables ------------------------------------------------------------
let $b7c88863cbfbcd57$var$msnryInterval;
const $b7c88863cbfbcd57$var$headerEl = document.querySelector('.header');
const $b7c88863cbfbcd57$var$pausedVideoEls = document.querySelectorAll('video[data-autoplay]');
const $b7c88863cbfbcd57$export$5e830c5f3cd8a610 = ()=>{
    // sets all the pages
    // console.log('setPage');
    // fix for local testing, before history in code ------------------------
    if (window.location.hostname.indexOf('192.168') > -1) {
        // replace in links
        const anchors = document.querySelectorAll('a');
        anchors.forEach((element)=>{
            const href = element.getAttribute('href');
            if (href) {
                const newLink = href.replace('localhost', window.location.hostname);
                element.setAttribute('href', newLink);
            }
        });
        // replace in forms
        const forms = document.querySelectorAll('form');
        forms.forEach((element)=>{
            const action = element.getAttribute('action');
            if (action) {
                const newLink = action.replace('localhost', window.location.hostname);
                element.setAttribute('action', newLink);
            }
        });
        // replace in images
        const imageEls = document.querySelectorAll('img');
        imageEls.forEach((imageEl)=>{
            const src = imageEl.getAttribute('data-src');
            if (src) {
                const newLink = src.split('localhost').join(window.location.hostname);
                imageEl.setAttribute('data-src', newLink);
            }
            const srcset = imageEl.getAttribute('data-srcset');
            if (srcset) {
                const newLink = srcset.split('localhost').join(window.location.hostname);
                imageEl.setAttribute('data-srcset', newLink);
            }
        });
        $baseUrl = $baseUrl.replace('localhost', window.location.hostname);
        $url = $url.replace('localhost', window.location.hostname);
        $assets = $assets.replace('localhost', window.location.hostname);
    }
    // setters -----------------------------------------------
    if (typeof MyHistory !== 'undefined') MyHistory.historySetPage();
    $cb5bd9b497a92a8a$export$74fd572b7937cf92();
    if ($pageType === 'project' && $b7c88863cbfbcd57$var$headerEl) $b7c88863cbfbcd57$var$headerEl.dataset.status = 'project';
    let msnry;
    const itemsEl = document.querySelector('.items--msnry');
    if (itemsEl) {
        msnry = new (0, (/*@__PURE__*/$parcel$interopDefault($dc83030be8593b5f$exports)))(itemsEl, {
            itemSelector: '.item',
            columnWidth: '.item--1',
            gutter: 30,
            transitionDuration: 0 // Disable animation
        });
        // before and after fader for reasons
        clearInterval($b7c88863cbfbcd57$var$msnryInterval);
        $b7c88863cbfbcd57$var$msnryInterval = setInterval(()=>{
            if (msnry) msnry.layout();
        }, 300);
        setTimeout(()=>{
            clearInterval($b7c88863cbfbcd57$var$msnryInterval);
            $b7c88863cbfbcd57$var$msnryInterval = setInterval(()=>{
                if (msnry) msnry.layout();
            }, 1000);
        }, 2000);
    }
    // if (!window.blPageTransition) // didn't always fire, or fired too early
    setInterval(()=>{
        // console.log('play');
        $b7c88863cbfbcd57$var$pausedVideoEls.forEach((videoEl)=>videoEl.play());
    }, 1200);
    // switch ($pageType) {
    // }
    if ('observerUnblocker' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.observerUnblocker(); // calls setResize
    // Once.fader -----------------------------------------------------
    // has to be called, because there is new content
    // must be after setting slick, because new elements are created
    setTimeout(()=>{
        if ('fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.setFaders();
    }, 0); // more than once js fader delay
};




// do this when loading everything
// so after loading all (non lazyloaded) images
// imports --------------------------------------------------------------------
// import * as Listeners from './1-listeners.js';


const $c8dbe1d1968f1b0e$export$1d4b3c81d8e95c45 = ()=>{
    // sets all the pages after loading
    // console.log('loadedPage');
    // into frame so it's not called before onready (which Firefox and Safari do)
    requestAnimationFrame(()=>{
        // because things might've changed after font/img loading
        $41264c54ad2c6427$export$1871afb4a41ded14(true);
        // scroll to hash?
        const hash = window.location.hash.substring(1);
        const el = document.getElementById(hash);
        if (hash && el) $b5ee8e0943d4762a$export$9e22b9da3b459613(el);
    });
};



// import * as VideoEmbed from './6-video-embed-v2.4.js';
// import * as MyHistory from './wb-history-v2.0.js';
// exported variables ---------------------------------------------------------
// local variables ------------------------------------------------------------
// functions -------------------------------------------------------------------
const $cba3eb2abed8e80a$var$init = ()=>{
    // so it's after pagereveal and you can use window.blPageTransition
    requestAnimationFrame(()=>{
        // console.log("init", Date.now());
        // Cookies.initCookies();
        $183c77cc0773b3dc$export$90d0ea046136e3ed();
        $592a2eb60fbd4a62$export$f699d83c57fc51d7();
        $56a526a578fe3239$export$caa6e1ba6b757214();
        $b7c88863cbfbcd57$export$5e830c5f3cd8a610();
        $41264c54ad2c6427$export$1a8cec7304e4a7df();
        $b5ee8e0943d4762a$export$44e7c48d94f0a708();
        $cb5bd9b497a92a8a$export$4ea236338c7d64ed();
    // VideoEmbed.initVideoEmbed();
    // MyHistory.initHistory();
    // console.log('init done');
    });
};
// console.log('This is the main JavaScript file.');
document.addEventListener('DOMContentLoaded', $cba3eb2abed8e80a$var$init);
window.addEventListener('load', $c8dbe1d1968f1b0e$export$1d4b3c81d8e95c45);


//# sourceMappingURL=partofabiggerplan.09e5e569.js.map
